import { jsx as n } from "react/jsx-runtime";
import { lazy as a, useMemo as p, Suspense as m } from "react";
function o(t) {
  return a(async () => await t());
}
const e = o(async () => import("../ArrowArcLeft-biyfc7It.js")), y = o(async () => import("../ArrowArcRight-MpTDDkDR.js")), l = o(async () => import("../ArrowBendDoubleUpLeft-D202r9PL.js")), u = o(async () => import("../ArrowBendDoubleUpRight-Bgx-donH.js")), g = o(async () => import("../ArrowBendDownLeft-Dk-8VKbR.js")), S = o(async () => import("../ArrowBendDownRight-T2atnbq1.js")), C = o(async () => import("../ArrowBendLeftDown-B0b3K50C.js")), h = o(async () => import("../ArrowBendLeftUp-B34p1M1M.js")), d = o(async () => import("../ArrowBendRightDown-KwfhREVa.js")), w = o(async () => import("../ArrowBendRightUp-BXZaOcaU.js")), A = o(async () => import("../ArrowBendUpLeft-DRnIpTJM.js")), L = o(async () => import("../ArrowBendUpRight-CCUUqtqR.js")), k = o(async () => import("../ArrowCircleDown-DYOuwR43.js")), P = o(async () => import("../ArrowCircleDownLeft-C5NqMi3I.js")), F = o(async () => import("../ArrowCircleDownRight-B5cvKTWJ.js")), b = o(async () => import("../ArrowCircleLeft-BPAD8ee7.js")), T = o(async () => import("../ArrowCircleRight-BvuKb67Z.js")), B = o(async () => import("../ArrowCircleUp-9F1PE5a3.js")), f = o(async () => import("../ArrowCircleUpLeft-DUzCPdzE.js")), D = o(async () => import("../ArrowCircleUpRight-CIGWek6w.js")), R = o(async () => import("../ArrowClockwise-B4a_vbQ4.js")), H = o(async () => import("../ArrowCounterClockwise-d0eGq35o.js")), M = o(async () => import("../ArrowDown-DtV67BgC.js")), U = o(async () => import("../ArrowDownLeft-B1rsDVV9.js")), N = o(async () => import("../ArrowDownRight-DWrO7WCo.js")), v = o(async () => import("../ArrowElbowDownLeft-B4e8xUaO.js")), x = o(async () => import("../ArrowElbowDownRight-CVLs8Zxp.js")), E = o(async () => import("../ArrowElbowLeft-CRuXYXWs.js")), G = o(async () => import("../ArrowElbowLeftDown-oc7UcErb.js")), W = o(async () => import("../ArrowElbowLeftUp-Cb8wr9bv.js")), O = o(async () => import("../ArrowElbowRight-lixfa4Nz.js")), q = o(async () => import("../ArrowElbowRightDown-FG069tFF.js")), I = o(async () => import("../ArrowElbowRightUp-CK6ZhN4L.js")), V = o(async () => import("../ArrowElbowUpLeft-C8VXk6AN.js")), z = o(async () => import("../ArrowElbowUpRight-JbgBpjL-.js")), X = o(async () => import("../ArrowFatDown-SF7wxFJq.js")), K = o(async () => import("../ArrowFatLeft-BuWAJQAq.js")), j = o(async () => import("../ArrowFatLineDown-B-cPvONe.js")), J = o(async () => import("../ArrowFatLineLeft-DFR9gfOW.js")), Z = o(async () => import("../ArrowFatLineRight-sUotu_2j.js")), Q = o(async () => import("../ArrowFatLinesDown-6S2mZm2e.js")), _ = o(async () => import("../ArrowFatLinesLeft-BW5P4LfN.js")), Y = o(async () => import("../ArrowFatLinesRight-Bf6tp1Sg.js")), $ = o(async () => import("../ArrowFatLinesUp-DM4TrpzM.js")), oo = o(async () => import("../ArrowFatLineUp-hzO5RNnw.js")), to = o(async () => import("../ArrowFatRight-Y6U9nhda.js")), no = o(async () => import("../ArrowFatUp-C8_8V-jG.js")), so = o(async () => import("../ArrowLeft-DLhz4DCP.js")), co = o(async () => import("../ArrowLineDown-B45HQMEg.js")), ro = o(async () => import("../ArrowLineDownLeft-DTIpuP_a.js")), io = o(async () => import("../ArrowLineDownRight-BoFv6uYE.js")), ao = o(async () => import("../ArrowLineLeft-v1dMmaFS.js")), po = o(async () => import("../ArrowLineRight-aJ8FqcDY.js")), mo = o(async () => import("../ArrowLineUp-scglsLuq.js")), eo = o(async () => import("../ArrowLineUpLeft-BJPlccfo.js")), yo = o(async () => import("../ArrowLineUpRight-ZDh4Mvre.js")), lo = o(async () => import("../ArrowRight-C85im21v.js")), uo = o(async () => import("../ArrowsClockwise-6IT4Pw1w.js")), go = o(async () => import("../ArrowsCounterClockwise-DP6eqw-J.js")), So = o(async () => import("../ArrowsDownUp-CfAtqT7V.js")), Co = o(async () => import("../ArrowsHorizontal-sdmZkMlO.js")), ho = o(async () => import("../ArrowsIn-IIeuysT6.js")), wo = o(async () => import("../ArrowsInCardinal-BD1tsPZY.js")), Ao = o(async () => import("../ArrowsInLineHorizontal-iWfUfKpC.js")), Lo = o(async () => import("../ArrowsInLineVertical-CST4htJO.js")), ko = o(async () => import("../ArrowsInSimple-J_OQ6ONm.js")), Po = o(async () => import("../ArrowsLeftRight-CVEwooxo.js")), Fo = o(async () => import("../ArrowsOut-xWtRBrJh.js")), bo = o(async () => import("../ArrowsOutCardinal-g7yykcs_.js")), To = o(async () => import("../ArrowsOutLineHorizontal-COawrkHY.js")), Bo = o(async () => import("../ArrowsOutLineVertical-G-q33G3i.js")), fo = o(async () => import("../ArrowsOutSimple-C8wmEErY.js")), Do = o(async () => import("../ArrowSquareDown-D2hNzwXx.js")), Ro = o(async () => import("../ArrowSquareDownLeft-C9Z1aL9w.js")), Ho = o(async () => import("../ArrowSquareDownRight-CLIr6VUm.js")), Mo = o(async () => import("../ArrowSquareIn-BlgbJ4D-.js")), Uo = o(async () => import("../ArrowSquareLeft-COwcMCIO.js")), No = o(async () => import("../ArrowSquareOut-CyO1Fyo7.js")), vo = o(async () => import("../ArrowSquareRight-B1rDG_1g.js")), xo = o(async () => import("../ArrowSquareUp-CGr6znNz.js")), Eo = o(async () => import("../ArrowSquareUpLeft-Caku07of.js")), Go = o(async () => import("../ArrowSquareUpRight-Dxqd6LZ1.js")), Wo = o(async () => import("../ArrowsVertical-CCH2TJER.js")), Oo = o(async () => import("../ArrowUDownLeft-Q_U03EiJ.js")), qo = o(async () => import("../ArrowUDownRight-D_oOaDIr.js")), Io = o(async () => import("../ArrowULeftDown-BLNpsnzq.js")), Vo = o(async () => import("../ArrowULeftUp-BqEnsAW9.js")), zo = o(async () => import("../ArrowUp-DGcoh4fd.js")), Xo = o(async () => import("../ArrowUpLeft-C_bBdzz3.js")), Ko = o(async () => import("../ArrowUpRight-DNCuiT-f.js")), jo = o(async () => import("../ArrowURightDown-DfRUv6jr.js")), Jo = o(async () => import("../ArrowURightUp-CV82FiQA.js")), Zo = o(async () => import("../ArrowUUpLeft-B5BBFhen.js")), Qo = o(async () => import("../ArrowUUpRight-DTP5ta5q.js")), _o = o(async () => import("../CaretCircleDoubleDown-Du5fKX29.js")), Yo = o(async () => import("../CaretCircleDoubleLeft-Cu6vnI_x.js")), $o = o(async () => import("../CaretCircleDoubleRight-CpqnfAm8.js")), ot = o(async () => import("../CaretCircleDoubleUp-8XZXAb5m.js")), tt = o(async () => import("../CaretCircleDown-C2pFXmx5.js")), nt = o(async () => import("../CaretCircleLeft-B-q59MwP.js")), st = o(async () => import("../CaretCircleRight-DDB-2RgI.js")), ct = o(async () => import("../CaretCircleUp-CPB7Jg89.js")), rt = o(async () => import("../CaretDoubleDown-C7av9Vlj.js")), it = o(async () => import("../CaretDoubleLeft-Cpm7Nnpg.js")), at = o(async () => import("../CaretDoubleRight-D0BORLTy.js")), pt = o(async () => import("../CaretDoubleUp-Vorwj7jI.js")), mt = o(async () => import("../CaretDown-qK3_eXZo.js")), et = o(async () => import("../CaretLeft-DuvNR0pW.js")), yt = o(async () => import("../CaretRight-CYw23ULp.js")), lt = o(async () => import("../CaretUp-BwXusn0Y.js")), ut = o(async () => import("../Recycle-DH-03Di7.js")), gt = o(async () => import("../AndroidLogo-CXpc30gG.js")), St = o(async () => import("../AngularLogo-CJ49bGxR.js")), Ct = o(async () => import("../AppleLogo-DITxu4jT.js")), ht = o(async () => import("../ApplePodcastsLogo-C0qhk_P9.js")), dt = o(async () => import("../AppStoreLogo-C35YXbe1.js")), wt = o(async () => import("../BehanceLogo-Dmjcsih5.js")), At = o(async () => import("../CodepenLogo-B_avmtH_.js")), Lt = o(async () => import("../CodesandboxLogo-CFjfBENr.js")), kt = o(async () => import("../DiscordLogo-tUDtZrJi.js")), Pt = o(async () => import("../DribbbleLogo-D8zrw4cn.js")), Ft = o(async () => import("../FacebookLogo-DKC3eDln.js")), bt = o(async () => import("../FigmaLogo-CmXPUFjx.js")), Tt = o(async () => import("../FramerLogo-Bi6BUbi-.js")), Bt = o(async () => import("../GithubLogo-D-Xvo95A.js")), ft = o(async () => import("../GitlabLogo-ntp8ls1v.js")), Dt = o(async () => import("../GitlabLogoSimple-DlpwWqwv.js")), Rt = o(async () => import("../GoogleChromeLogo-JVHlZ7Up.js")), Ht = o(async () => import("../GoogleLogo-BztR-tJk.js")), Mt = o(async () => import("../GooglePhotosLogo-78HEbLwe.js")), Ut = o(async () => import("../GooglePlayLogo-BwOEChPr.js")), Nt = o(async () => import("../GooglePodcastsLogo-CRRsdtwk.js")), vt = o(async () => import("../InstagramLogo-DrW6q_iy.js")), xt = o(async () => import("../LinkedinLogo-CdJeiMCb.js")), Et = o(async () => import("../LinuxLogo-Bb93SR9j.js")), Gt = o(async () => import("../MediumLogo-f_lJY1az.js")), Wt = o(async () => import("../MessengerLogo-CSiKTL5W.js")), Ot = o(async () => import("../MicrosoftExcelLogo-C6mOWksj.js")), qt = o(async () => import("../MicrosoftPowerpointLogo-CNqRlzOC.js")), It = o(async () => import("../MicrosoftTeamsLogo-Cat_72Qt.js")), Vt = o(async () => import("../MicrosoftWordLogo-D_WW0h4A.js")), zt = o(async () => import("../NyTimesLogo-BefCu_a5.js")), Xt = o(async () => import("../PhosphorLogo-blQ-1raU.js")), Kt = o(async () => import("../PinterestLogo-CtkLh7jX.js")), jt = o(async () => import("../RedditLogo-DDbiQA0v.js")), Jt = o(async () => import("../SketchLogo-DITmri_5.js")), Zt = o(async () => import("../SlackLogo-Dh9srMAk.js")), Qt = o(async () => import("../SnapchatLogo-CoqAImmQ.js")), _t = o(async () => import("../SpotifyLogo-GB1sYNr_.js")), Yt = o(async () => import("../SquareLogo-DU0eF7XP.js")), $t = o(async () => import("../StackOverflowLogo-D4H-NZXq.js")), on = o(async () => import("../StripeLogo-hgbjrHf9.js")), tn = o(async () => import("../TelegramLogo-C0_BX4BQ.js")), nn = o(async () => import("../TiktokLogo-BoVu-7UN.js")), sn = o(async () => import("../TwitchLogo-CZyj24QY.js")), cn = o(async () => import("../TwitterLogo-C8gL__ac.js")), rn = o(async () => import("../WhatsappLogo-8AzM-sAn.js")), an = o(async () => import("../WindowsLogo-Df7y6-7J.js")), pn = o(async () => import("../YoutubeLogo-BQBGiCCl.js")), mn = o(async () => import("../Armchair-BG5oRIM8.js")), en = o(async () => import("../Backpack-BxeFMnSM.js")), yn = o(async () => import("../Bag-9IspRA0E.js")), ln = o(async () => import("../BagSimple-CH7YaZhq.js")), un = o(async () => import("../Balloon-BRmtBUzh.js")), gn = o(async () => import("../Barcode-B-JKusaK.js")), Sn = o(async () => import("../Bathtub-DM2xZaoT.js")), Cn = o(async () => import("../BeerBottle-FzlSJYT3.js")), hn = o(async () => import("../Binoculars-DR7oNH5G.js")), dn = o(async () => import("../Brandy-BpVtJ6FY.js")), wn = o(async () => import("../Buildings-uJeY3VvC.js")), An = o(async () => import("../Cake-Bx1Dg_dU.js")), Ln = o(async () => import("../Cardholder-D8ItL5qO.js")), kn = o(async () => import("../CoatHanger-D4-yJufQ.js")), Pn = o(async () => import("../Coffee-BtD7LEYP.js")), Fn = o(async () => import("../Coin-B6d7q-ml.js")), bn = o(async () => import("../Coins-D8ChYBNU.js")), Tn = o(async () => import("../CoinVertical-CdXvPt9Z.js")), Bn = o(async () => import("../Cookie-P07B22Rh.js")), fn = o(async () => import("../CookingPot-C1C3ECv0.js")), Dn = o(async () => import("../CreditCard-Ci87ytUm.js")), Rn = o(async () => import("../CurrencyBtc-C579UVWK.js")), Hn = o(async () => import("../CurrencyCircleDollar-BERrbJIl.js")), Mn = o(async () => import("../CurrencyCny-BsW8Zkdj.js")), Un = o(async () => import("../CurrencyDollar-6K2W5EWd.js")), Nn = o(async () => import("../CurrencyDollarSimple-DRqxBu0h.js")), vn = o(async () => import("../CurrencyEth-4IWvssr6.js")), xn = o(async () => import("../CurrencyEur-B_7QWEi6.js")), En = o(async () => import("../CurrencyGbp-DgJxLADW.js")), Gn = o(async () => import("../CurrencyInr-0B38_PsH.js")), Wn = o(async () => import("../CurrencyJpy-DKCvphyW.js")), On = o(async () => import("../CurrencyKrw-BdTs9Ome.js")), qn = o(async () => import("../CurrencyKzt-DygAPwrX.js")), In = o(async () => import("../CurrencyNgn-oEJ4VM-W.js")), Vn = o(async () => import("../CurrencyRub-BjLM2GXh.js")), zn = o(async () => import("../Egg-B9O5Byhp.js")), Xn = o(async () => import("../EggCrack-CWWCS7Tb.js")), Kn = o(async () => import("../Eyeglasses-C6FLt-_n.js")), jn = o(async () => import("../Factory-wSnwOvzu.js")), Jn = o(async () => import("../ForkKnife-BE3unQuN.js")), Zn = o(async () => import("../Gift-CTvckQE8.js")), Qn = o(async () => import("../Hamburger-Hz3gh3cr.js")), _n = o(async () => import("../Handbag-Cj3r3uq-.js")), Yn = o(async () => import("../HandbagSimple-HkFTeCBc.js")), $n = o(async () => import("../HandCoins-JVeg_xKU.js")), os = o(async () => import("../Knife-zFKXSvSp.js")), ts = o(async () => import("../Ladder-eYmoP5FU.js")), ns = o(async () => import("../LadderSimple-COEVEhsU.js")), ss = o(async () => import("../Lamp-Br_viqIi.js")), cs = o(async () => import("../Martini-D6q1QTef.js")), rs = o(async () => import("../Money-Bi4W3O30.js")), is = o(async () => import("../Needle-DQuC5its.js")), as = o(async () => import("../Package-D_89Qn6p.js")), ps = o(async () => import("../Pizza-B_tO_QiL.js")), ms = o(async () => import("../Popcorn-CSGXTpvy.js")), es = o(async () => import("../Receipt-qQWnmq8-.js")), ys = o(async () => import("../Rug-C7hDgFu1.js")), ls = o(async () => import("../Scales-BBXAuPEB.js")), us = o(async () => import("../ShoppingBag-C12MnwVf.js")), gs = o(async () => import("../ShoppingBagOpen-DM0shMz3.js")), Ss = o(async () => import("../ShoppingCart-BZC66r9b.js")), Cs = o(async () => import("../ShoppingCartSimple-yEwmwsSN.js")), hs = o(async () => import("../Shower-C7kBhhM_.js")), ds = o(async () => import("../Storefront-BlWiWHTC.js")), ws = o(async () => import("../Sunglasses-ykw99-R1.js")), As = o(async () => import("../Tag-CYCPxXrb.js")), Ls = o(async () => import("../TagChevron-0l6InnvM.js")), ks = o(async () => import("../TagSimple-O5DeTVIu.js")), Ps = o(async () => import("../Ticket-Bguiq2q4.js")), Fs = o(async () => import("../Tote-CYg2VcYY.js")), bs = o(async () => import("../ToteSimple-CyRkSZ-E.js")), Ts = o(async () => import("../TrademarkRegistered-CEf0KLQB.js")), Bs = o(async () => import("../TShirt-BL73HSSl.js")), fs = o(async () => import("../Wallet-D1aChROl.js")), Ds = o(async () => import("../Wine-CuINOVzs.js")), Rs = o(async () => import("../AddressBook-BkCK-fmq.js")), Hs = o(async () => import("../Asterisk-HN6eDXMk.js")), Ms = o(async () => import("../AsteriskSimple-66_4qP6B.js")), Us = o(async () => import("../At-swAHOP5v.js")), Ns = o(async () => import("../Broadcast-CtEjpAVS.js")), vs = o(async () => import("../Chat-DU1QZ4-8.js")), xs = o(async () => import("../ChatCentered-C2bjmkNx.js")), Es = o(async () => import("../ChatCenteredDots-D753u0-v.js")), Gs = o(async () => import("../ChatCenteredText-QArShDuh.js")), Ws = o(async () => import("../ChatCircle-O0bW7h6v.js")), Os = o(async () => import("../ChatCircleDots-D7zjPHUf.js")), qs = o(async () => import("../ChatCircleText-Cd8m8uUK.js")), Is = o(async () => import("../ChatDots-6vtXK925.js")), Vs = o(async () => import("../Chats-CVKaXA2Y.js")), zs = o(async () => import("../ChatsCircle-DOEPpPWl.js")), Xs = o(async () => import("../ChatsTeardrop-DHMgPtAI.js")), Ks = o(async () => import("../ChatTeardrop-Bs7Fsujm.js")), js = o(async () => import("../ChatTeardropDots-EPoz9g-d.js")), Js = o(async () => import("../ChatTeardropText-DBdZYl_r.js")), Zs = o(async () => import("../ChatText-CByK1Qcl.js")), Qs = o(async () => import("../Envelope-CcTSaZx8.js")), _s = o(async () => import("../EnvelopeOpen-_LFT4TI6.js")), Ys = o(async () => import("../EnvelopeSimple-DXWCjJh2.js")), $s = o(async () => import("../EnvelopeSimpleOpen-DkyoZ9p8.js")), oc = o(async () => import("../Export-CWe-Dgid.js")), tc = o(async () => import("../Hash-CAak7MO2.js")), nc = o(async () => import("../HashStraight-DhEjAGx9.js")), sc = o(async () => import("../Megaphone-BUbRh9S3.js")), cc = o(async () => import("../MegaphoneSimple-CPOOZmLE.js")), rc = o(async () => import("../PaperPlane-SPqDf30L.js")), ic = o(async () => import("../PaperPlaneRight-B9ITEJKu.js")), ac = o(async () => import("../PaperPlaneTilt-BY4BpZ5B.js")), pc = o(async () => import("../Peace-BSOZ4Kbe.js")), mc = o(async () => import("../Phone-BedNhLUl.js")), ec = o(async () => import("../PhoneCall-CM6fFwA_.js")), yc = o(async () => import("../PhoneDisconnect-Ce4rDQ4J.js")), lc = o(async () => import("../PhoneIncoming-DalCIHXz.js")), uc = o(async () => import("../PhoneOutgoing-CpWRpbTI.js")), gc = o(async () => import("../PhoneSlash-PP7r5fGF.js")), Sc = o(async () => import("../PhoneX-CJUdm13f.js")), Cc = o(async () => import("../Quotes-Chao-YZY.js")), hc = o(async () => import("../Radio-UHUkc4Fc.js")), dc = o(async () => import("../Rss-CR7mGkHo.js")), wc = o(async () => import("../RssSimple-DmC5S5yh.js")), Ac = o(async () => import("../Share-CcwhZxe0.js")), Lc = o(async () => import("../ShareNetwork-BZ32LBKe.js")), kc = o(async () => import("../Star-hk2Be2Xc.js")), Pc = o(async () => import("../StarHalf-B-CJvjvD.js")), Fc = o(async () => import("../Sticker-B-3ikMLn.js")), bc = o(async () => import("../ThumbsDown-t7HkA1rV.js")), Tc = o(async () => import("../ThumbsUp-CFmjNN-A.js")), Bc = o(async () => import("../Translate-DCT_Hycp.js")), fc = o(async () => import("../Voicemail-YJsnW4iI.js")), Dc = o(async () => import("../YinYang-D3_DspST.js")), Rc = o(async () => import("../AlignBottom-Bpo5PxZ1.js")), Hc = o(async () => import("../AlignBottomSimple-q7tXHtVL.js")), Mc = o(async () => import("../AlignCenterHorizontal-8A89rMqx.js")), Uc = o(
  async () => import("../AlignCenterHorizontalSimple-xRFmFlje.js")
), Nc = o(async () => import("../AlignCenterVertical-BMvqsY9j.js")), vc = o(
  async () => import("../AlignCenterVerticalSimple-syZcKjlv.js")
), xc = o(async () => import("../AlignLeft-yH6XcCAb.js")), Ec = o(async () => import("../AlignLeftSimple-jjti2v_O.js")), Gc = o(async () => import("../AlignRight-fIunwfsy.js")), Wc = o(async () => import("../AlignRightSimple-D8S_gBl_.js")), Oc = o(async () => import("../AlignTop-B7Eu1E73.js")), qc = o(async () => import("../AlignTopSimple-B7PNNxjm.js")), Ic = o(async () => import("../BezierCurve-C7cE_kaZ.js")), Vc = o(async () => import("../BoundingBox-Cv5asoPt.js")), zc = o(async () => import("../Circle-CSE1Ju6P.js")), Xc = o(async () => import("../CircleDashed-D_orq-Bm.js")), Kc = o(async () => import("../CircleHalf-CayodpLi.js")), jc = o(async () => import("../CircleHalfTilt-Doncf-Zc.js")), Jc = o(async () => import("../CircleNotch-XEVL45p_.js")), Zc = o(async () => import("../CirclesFour-DhlWLbPp.js")), Qc = o(async () => import("../CirclesThree-CHrsf_Lw.js")), _c = o(async () => import("../CirclesThreePlus-C5-w_m4i.js")), Yc = o(async () => import("../Columns-ovVM_RoP.js")), $c = o(async () => import("../Crop-dgHwurdv.js")), or = o(async () => import("../Cube-DEfZLmIZ.js")), tr = o(async () => import("../Cylinder-j9-FYyt1.js")), nr = o(async () => import("../DiamondsFour-Dm2xHF9H.js")), sr = o(async () => import("../DropHalf-B-E0zWje.js")), cr = o(async () => import("../DropHalfBottom-C8tOiahG.js")), rr = o(async () => import("../Eraser-g5f-Kzqi.js")), ir = o(async () => import("../Eye-CrdRbAhE.js")), ar = o(async () => import("../EyeClosed-CXHJCM6N.js")), pr = o(async () => import("../Eyedropper-CIz7el-c.js")), mr = o(async () => import("../EyedropperSample-C3stFd_S.js")), er = o(async () => import("../EyeSlash-WxSc8izh.js")), yr = o(async () => import("../FlowArrow-V6XFdmjh.js")), lr = o(async () => import("../Gradient-C0ByRDvN.js")), ur = o(async () => import("../GridFour-vojrP9h5.js")), gr = o(async () => import("../Hexagon-CbtJAN9n.js")), Sr = o(async () => import("../HighlighterCircle-Zwi8jsTd.js")), Cr = o(async () => import("../Intersect-NVMimChw.js")), hr = o(async () => import("../Layout-BX4MCniH.js")), dr = o(async () => import("../LineSegment-CTMbCkbw.js")), wr = o(async () => import("../LineSegments-kvCmN3kM.js")), Ar = o(async () => import("../MagicWand-CYt8DFUi.js")), Lr = o(async () => import("../MarkerCircle-BZM3WQk9.js")), kr = o(async () => import("../Octagon-DHhQUQ3O.js")), Pr = o(async () => import("../PaintBrush-IAREqZ9n.js")), Fr = o(async () => import("../PaintBrushBroad-gV4vAwka.js")), br = o(async () => import("../PaintBrushHousehold-DFJgKU4G.js")), Tr = o(async () => import("../PaintBucket-BYFxJyKe.js")), Br = o(async () => import("../PaintRoller-BBBUg3RQ.js")), fr = o(async () => import("../Palette-pT75tKQT.js")), Dr = o(async () => import("../Pen-CZBTfsC4.js")), Rr = o(async () => import("../Pencil-DQZ9Vd_3.js")), Hr = o(async () => import("../PencilCircle-BdTC3Tbq.js")), Mr = o(async () => import("../PencilLine-CMFC8McC.js")), Ur = o(async () => import("../PencilSimple-CML7_LVI.js")), Nr = o(async () => import("../PencilSimpleLine-nuUslh_F.js")), vr = o(async () => import("../PenNib-BKe6oVQS.js")), xr = o(async () => import("../PenNibStraight-C4rV-WO2.js")), Er = o(async () => import("../Perspective-C-ERtuAo.js")), Gr = o(async () => import("../Placeholder--X8_oFjt.js")), Wr = o(async () => import("../Polygon-BbGjOscE.js")), Or = o(async () => import("../Rectangle-q9lLTic2.js")), qr = o(async () => import("../Rows-Dx61xbmx.js")), Ir = o(async () => import("../Ruler-PMfJlFEP.js")), Vr = o(async () => import("../Scissors-Ca0m8B_s.js")), zr = o(async () => import("../ScribbleLoop-BKCKfPNZ.js")), Xr = o(async () => import("../Selection-pVuZ4G0I.js")), Kr = o(async () => import("../SelectionAll-DY-vnknA.js")), jr = o(async () => import("../SelectionBackground-DMmx0ETF.js")), Jr = o(async () => import("../SelectionForeground-M5f9CjNw.js")), Zr = o(async () => import("../SelectionInverse-DFGWArDt.js")), Qr = o(async () => import("../SelectionPlus-JgwpTesi.js")), _r = o(async () => import("../SelectionSlash-BOz1A7hI.js")), Yr = o(async () => import("../Sidebar-DszzYb7p.js")), $r = o(async () => import("../SidebarSimple-BNW7NoVE.js")), oi = o(async () => import("../Square-7pwGO9dQ.js")), ti = o(async () => import("../SquareHalf-B5slLOhu.js")), ni = o(async () => import("../SquareHalfBottom-DogfNinz.js")), si = o(async () => import("../SquaresFour-t4sNqbPa.js")), ci = o(async () => import("../Stack-oSqUHVVW.js")), ri = o(async () => import("../StackSimple-82CgtO1n.js")), ii = o(async () => import("../Stamp-BsnjN0h-.js")), ai = o(async () => import("../Swatches-dbAnjeVY.js")), pi = o(async () => import("../Triangle-BUJ-C_lK.js")), mi = o(async () => import("../Vignette-C2NQ0Bqv.js")), ei = o(async () => import("../BracketsAngle-CEnEqwkY.js")), yi = o(async () => import("../BracketsCurly-D3wAzkxx.js")), li = o(async () => import("../BracketsRound-C6NXNUTK.js")), ui = o(async () => import("../BracketsSquare-oXSR7IWc.js")), gi = o(async () => import("../Bug-BiUHIavw.js")), Si = o(async () => import("../BugBeetle-Zf5NvVx7.js")), Ci = o(async () => import("../BugDroid-C29YjQBo.js")), hi = o(async () => import("../Code-BheH01SJ.js")), di = o(async () => import("../CodeSimple-DtEH0drH.js")), wi = o(async () => import("../Cpu-DgU6C2zW.js")), Ai = o(async () => import("../Database-1stFly77.js")), Li = o(async () => import("../GitBranch-BDpWqtee.js")), ki = o(async () => import("../GitCommit-BJNV-5IR.js")), Pi = o(async () => import("../GitDiff-BYhqpbwj.js")), Fi = o(async () => import("../GitFork-Clfy3I-H.js")), bi = o(async () => import("../GitMerge-DhsPGEnt.js")), Ti = o(async () => import("../GitPullRequest-Hsqd20r9.js")), Bi = o(async () => import("../Magnet-B8FiMkmd.js")), fi = o(async () => import("../MagnetStraight-CRH2eMgK.js")), Di = o(async () => import("../Robot-CtlX93a1.js")), Ri = o(async () => import("../Terminal-BcTV4TgZ.js")), Hi = o(async () => import("../TerminalWindow-D1VkZc86.js")), Mi = o(async () => import("../TreeStructure-Cl_z25yp.js")), Ui = o(async () => import("../Book-CYBZgU__.js")), Ni = o(async () => import("../BookBookmark-xRMmyo-_.js")), vi = o(async () => import("../Bookmark-DOjbA0Ug.js")), xi = o(async () => import("../Bookmarks-CLMblJtI.js")), Ei = o(async () => import("../BookmarkSimple-Ct7x6sVk.js")), Gi = o(async () => import("../BookmarksSimple-DepxywdP.js")), Wi = o(async () => import("../BookOpen-sOOG6QuX.js")), Oi = o(async () => import("../Books-BemgfJxa.js")), qi = o(async () => import("../Chalkboard--AV888jd.js")), Ii = o(async () => import("../ChalkboardSimple-CFtJ9Bvx.js")), Vi = o(async () => import("../ChalkboardTeacher-BfLxG_J3.js")), zi = o(async () => import("../Exam-D7AspXDL.js")), Xi = o(async () => import("../GraduationCap-BFoVY0mC.js")), Ki = o(async () => import("../Student-C0nyxR6r.js")), ji = o(async () => import("../AlignCenter-6oj6fAVf.js")), Ji = o(async () => import("../AlignJustify-Bb95N60l.js")), Zi = o(async () => import("../AlignLeftAlt-CvfmKbca.js")), Qi = o(async () => import("../AlignRightAlt-CZ3OawAy.js")), _i = o(async () => import("../AngleArrowDown-CHlXPCTr.js")), Yi = o(async () => import("../AngleArrowLeft-C7RDbyV0.js")), $i = o(async () => import("../AngleArrowRight-frIzliIv.js")), oa = o(async () => import("../AngleArrowSmallDown-qFAoqmwg.js")), ta = o(async () => import("../AngleArrowSmallLeft-D2A2Pi2i.js")), na = o(async () => import("../AngleArrowSmallRight-R6OqKOrL.js")), sa = o(async () => import("../AngleArrowSmallUp-DeLz9bnS.js")), ca = o(async () => import("../AngleArrowUp-Cd1wdZw1.js")), ra = o(async () => import("../Apply-sd8uOWZ3.js")), ia = o(async () => import("../ArrowBottom-uEvKietN.js")), aa = o(async () => import("../ArrowLeftAlt-lJiZ7SEP.js")), pa = o(async () => import("../ArrowLeftBottom-DyxSyDWv.js")), ma = o(async () => import("../ArrowLeftTop-TyNnKI4g.js")), ea = o(async () => import("../ArrowRightAlt-BH8YOl1d.js")), ya = o(async () => import("../ArrowRightBottom-gNul-hbA.js")), la = o(async () => import("../ArrowRightTop-EmSEoj3C.js")), ua = o(async () => import("../ArrowsLeftAndRight-BJI7L3qk.js")), ga = o(async () => import("../ArrowsUpAndDown-Dyw2R7Xb.js")), Sa = o(async () => import("../ArrowTop-WcMSIhYe.js")), Ca = o(async () => import("../Back-DM9XZmwZ.js")), ha = o(async () => import("../BarChart-FQFAiOcN.js")), da = o(async () => import("../BedAlt-DiZuk8w7.js")), wa = o(async () => import("../BellAlt-CwdeNeNg.js")), Aa = o(async () => import("../Bin-D7gaUzYs.js")), La = o(async () => import("../BookmarkAlt-B12sEAUa.js")), ka = o(async () => import("../BoxesArrowsLeftRight-DaMvLwUZ.js")), Pa = o(async () => import("../BuildingsAlt-Dlm4HXuM.js")), Fa = o(async () => import("../Bulb-Dz2boMF7.js")), ba = o(async () => import("../CalculatorAlt-WiCuf5aD.js")), Ta = o(async () => import("../CalendarAlt-BYiaA18_.js")), Ba = o(async () => import("../CameraAlt-DZ9yGWq7.js")), fa = o(async () => import("../Cart-W74Q8yoJ.js")), Da = o(async () => import("../CartCrossInside-f6CLTBdx.js")), Ra = o(async () => import("../CartPlusInside-8Z0Llnzz.js")), Ha = o(async () => import("../CarTwo-DOnd5r0G.js")), Ma = o(async () => import("../Case-D87STwRC.js")), Ua = o(async () => import("../CheckmarkRound-BZbtGS34.js")), Na = o(async () => import("../CloudCheckmarkOne-DsX7BL1I.js")), va = o(async () => import("../CloudCopy-Ds7qF4Q2.js")), xa = o(async () => import("../CloudCross-XVQHzi4D.js")), Ea = o(async () => import("../CloudDisconnected-DzgGTC6h.js")), Ga = o(async () => import("../CloudDownload-BTakaKyz.js")), Wa = o(async () => import("../CloudServerCopy-DLhYFbDc.js")), Oa = o(async () => import("../CloudUpload-D5FfPnDt.js")), qa = o(async () => import("../Collapse-CGa9OZE3.js")), Ia = o(async () => import("../CollapseSmall-DSVsArXo.js")), Va = o(async () => import("../CreditCardAlt-Dy4X7QnZ.js")), za = o(async () => import("../Cross-_yDV11zW.js")), Xa = o(async () => import("../CursorAlt-DFaP5k6H.js")), Ka = o(async () => import("../DashboardFour-CiUTsTDw.js")), ja = o(async () => import("../DashboardLines-BcnPWCk_.js")), Ja = o(async () => import("../DatabaseOne-BrjFoUc-.js")), Za = o(async () => import("../Dialog-BjmMQhMJ.js")), Qa = o(async () => import("../DiamondAlt-k7x1I6k7.js")), _a = o(async () => import("../Distance-CS-3fWfn.js")), Ya = o(async () => import("../DownloadAlt-CGmSJUJb.js")), $a = o(async () => import("../Drag-DhQZN2N2.js")), op = o(async () => import("../DropperOne-BksfmjVV.js")), tp = o(async () => import("../Earth-ClS0IT1v.js")), np = o(async () => import("../ExitLeft-B5tnTIjl.js")), sp = o(async () => import("../ExitRight-4cZ8S_wU.js")), cp = o(async () => import("../Expand-T1bpF018.js")), rp = o(async () => import("../ExpandSmall-DqVEnDLO.js")), ip = o(async () => import("../EyeAlt-CJuY2zQ7.js")), ap = o(async () => import("../EyeCrossedOut-qwPK9xsM.js")), pp = o(async () => import("../Filter-FcEe6mmB.js")), mp = o(async () => import("../FlagAlt-BK9YZnTD.js")), ep = o(async () => import("../Flash-aFilQ7EL.js")), yp = o(async () => import("../FolderOpenAlt-dE3cpi9Z.js")), lp = o(async () => import("../FolderClosed-BsGoiUYJ.js")), up = o(async () => import("../FullScreen-C-vEMN8H.js")), gp = o(async () => import("../GamePad-CuZPjrEC.js")), Sp = o(async () => import("../GearAlt-kK2TZnA2.js")), Cp = o(async () => import("../HamburgerMenu-C6cjpaJ_.js")), hp = o(async () => import("../HandPointer-UJ-6ZRgj.js")), dp = o(async () => import("../HashAlt-Cwoki7Vc.js")), wp = o(async () => import("../HeadphonesAlt-CPUcEVHf.js")), Ap = o(async () => import("../HeadphonesWithMicrophone-B0p5jXzW.js")), Lp = o(async () => import("../HeartAlt-BcO5Ys44.js")), kp = o(async () => import("../HeartFilled-CZ-SNqmc.js")), Pp = o(async () => import("../InfoAlt-S9iRInK2.js")), Fp = o(async () => import("../Label-CxbUC1rg.js")), bp = o(async () => import("../LightningAlt-CEuhxnUJ.js")), Tp = o(async () => import("../LinkAlt-D9BkE4ic.js")), Bp = o(async () => import("../ListAlt-CKHonuWM.js")), fp = o(async () => import("../ListCheckmarks-DWqfbpUr.js")), Dp = o(async () => import("../Location-Dfuiw9hx.js")), Rp = o(async () => import("../LockClosed-CXJFEgKC.js")), Hp = o(async () => import("../LockOpened-COmQ7v3L.js")), Mp = o(async () => import("../Magnifier-jHYWhXMd.js")), Up = o(async () => import("../MagnifierMinus-Cw2KI9f4.js")), Np = o(async () => import("../MagnifierPlus-CNxqIrCg.js")), vp = o(async () => import("../Mail-Cl3QBYtm.js")), xp = o(async () => import("../MedicalCross-D5qU6Xkp.js")), Ep = o(async () => import("../MicrophoneAlt-Codf6TAm.js")), Gp = o(async () => import("../MinusRound-Dnn08KFw.js")), Wp = o(async () => import("../MoneyAlt-BZdEx57x.js")), Op = o(async () => import("../MonitorOne-BrGHfn-b.js")), qp = o(async () => import("../MonitorPhoneTwo-SZdWwKDC.js")), Ip = o(async () => import("../MouseAlt-jgeDznTf.js")), Vp = o(async () => import("../Music-DJRvD-hB.js")), zp = o(async () => import("../Network-CekKLs58.js")), Xp = o(async () => import("../NoSound-u19BGYe-.js")), Kp = o(async () => import("../NotesVertical-DiafDIUC.js")), jp = o(async () => import("../PackageAlt-CbHquvMx.js")), Jp = o(async () => import("../Paper-K3U0fZB-.js")), Zp = o(async () => import("../PaperclipAlt-D_XzUhUh.js")), Qp = o(async () => import("../ParkingCircle-Lr4JMS4_.js")), _p = o(async () => import("../Pensil-CloTV7_N.js")), Yp = o(async () => import("../PercentSymbol-5HzmDUDu.js")), $p = o(async () => import("../PhoneCheckmark-i3e-qesz.js")), om = o(async () => import("../PhoneMinus-BnW3EIai.js")), tm = o(async () => import("../PhonePlus-CqBm96tF.js")), nm = o(async () => import("../PhoneRings-Dd11aKm8.js")), sm = o(async () => import("../Picture-C26xV46M.js")), cm = o(async () => import("../PieChart-bu5vBrYI.js")), rm = o(async () => import("../Pin-NyIk44F_.js")), im = o(async () => import("../Plane-6c6V6wDb.js")), am = o(async () => import("../PlayVideoRectangle-OfmJcI2T.js")), pm = o(async () => import("../PlusAlt-C2ZZnc14.js")), mm = o(async () => import("../PlusRound-DE_DdoHy.js")), em = o(async () => import("../PokerFace-CT0qq45z.js")), ym = o(async () => import("../Recover-07wGvouO.js")), lm = o(async () => import("../RepeatAlt-DonjVgiH.js")), um = o(async () => import("../RestoreDown-kgD9Jkbb.js")), gm = o(async () => import("../Sad-WvvlgX3U.js")), Sm = o(async () => import("../Save-BTz0I8C-.js")), Cm = o(async () => import("../SettingsVertical-Bt0iwakn.js")), hm = o(async () => import("../ShieldOne-6Ay7auNf.js")), dm = o(async () => import("../ShoppingBagHandlesDown-Bf0-l_ej.js")), wm = o(async () => import("../Smartphone-D1f0gmDz.js")), Am = o(async () => import("../Smile-DyPee_uG.js")), Lm = o(async () => import("../Sort-CeuM4VvE.js")), km = o(async () => import("../SortArrowDown-DC4oafxn.js")), Pm = o(async () => import("../SortArrowUp-CPsH4syd.js")), Fm = o(async () => import("../SoundHigh-BW8hmgnm.js")), bm = o(async () => import("../SoundLow-D-S7kC70.js")), Tm = o(async () => import("../SpeechBubble-BSnsARu3.js")), Bm = o(async () => import("../SplitScreenHorizontal-C7XJiiRY.js")), fm = o(async () => import("../SplitScreenVertical-DZmwfaPZ.js")), Dm = o(async () => import("../SpoonAndFork-DXQ7roLt.js")), Rm = o(async () => import("../StarAlt-BCy64Zru.js")), Hm = o(async () => import("../TableAlt-DjD70gIl.js")), Mm = o(async () => import("../TargetAlt-DzfGvUT8.js")), Um = o(async () => import("../ThumbsDownAlt-BOGMFFZl.js")), Nm = o(async () => import("../ThumbsUpAlt-BkdEZF2v.js")), vm = o(async () => import("../Tools-BL4alY-L.js")), xm = o(async () => import("../TruckAlt-B0js6syb.js")), Em = o(async () => import("../UnevenLineGraph-B6_dvwOS.js")), Gm = o(async () => import("../UploadAlt-koNvGUP4.js")), Wm = o(async () => import("../UsdCircle-DqkevfFP.js")), Om = o(async () => import("../UserAlt-DnjAM6qP.js")), qm = o(async () => import("../UserRound-CEUdSOGk.js")), Im = o(async () => import("../UsersAlt-BKqYdQaj.js")), Vm = o(async () => import("../VideoCameraAlt-D-GEDzXM.js")), zm = o(async () => import("../Waiting-Ca7gs5m5.js")), Xm = o(async () => import("../WarningAlt-qzyf1e14.js")), Km = o(async () => import("../WatchAlt-Ctp-THQ3.js")), jm = o(async () => import("../Website-Cebg8EL0.js")), Jm = o(async () => import("../WrenchAlt-CblFJspH.js")), Zm = o(async () => import("../Writing-BaI9lUZG.js")), Qm = o(async () => import("../XRound-CoLvVs3I.js")), _m = o(async () => import("../Alien-BIT_QH2F.js")), Ym = o(async () => import("../Baseball-BjklDnc7.js")), $m = o(async () => import("../Basketball-BO05lLXx.js")), oe = o(async () => import("../Club-DgRPDFfB.js")), te = o(async () => import("../Confetti-CyThXXV-.js")), ne = o(async () => import("../Crown-D77brGQU.js")), se = o(async () => import("../CrownSimple-BLS9KHIF.js")), ce = o(async () => import("../Diamond-DjZJK7K2.js")), re = o(async () => import("../DiceFive-TEAB1Fba.js")), ie = o(async () => import("../DiceFour-Cr9qjHTC.js")), ae = o(async () => import("../DiceOne-Ce8tfB71.js")), pe = o(async () => import("../DiceSix-DBMLgmZh.js")), me = o(async () => import("../DiceThree-ZTTc_7Zo.js")), ee = o(async () => import("../DiceTwo-Ds3QOR3G.js")), ye = o(async () => import("../FinnTheHuman-Mssmv0Hu.js")), le = o(async () => import("../FlyingSaucer-DBUG_mzt.js")), ue = o(async () => import("../Football-FQcQJ5NE.js")), ge = o(async () => import("../GameController-DRV5WoKp.js")), Se = o(async () => import("../Ghost-MkiOcdeg.js")), Ce = o(async () => import("../Heart-BpTonKe_.js")), he = o(async () => import("../HeartBreak-DMO8khYU.js")), de = o(async () => import("../HeartStraight-I9NX7lXB.js")), we = o(async () => import("../HeartStraightBreak-Clpmq-Bn.js")), Ae = o(async () => import("../Horse-CYFnuT5Q.js")), Le = o(async () => import("../MaskHappy-h3izJqQP.js")), ke = o(async () => import("../MaskSad-xJ44KhQj.js")), Pe = o(async () => import("../Medal-BaOLyD6n.js")), Fe = o(async () => import("../Parachute-Cc_9JG6v.js")), be = o(async () => import("../Pinwheel-BeCdKAVG.js")), Te = o(async () => import("../PokerChip-D1APhRIR.js")), Be = o(async () => import("../PuzzlePiece-Bn8_hsXo.js")), fe = o(async () => import("../Scroll-DO1TkSQ4.js")), De = o(async () => import("../Skull-BbV_Fra3.js")), Re = o(async () => import("../SoccerBall-D07GI4nW.js")), He = o(async () => import("../Spade-CN--bDgC.js")), Me = o(async () => import("../Spiral-Q7-jyOF4.js")), Ue = o(async () => import("../Strategy-0rs_s0xl.js")), Ne = o(async () => import("../Sword-D_DeyTSc.js")), ve = o(async () => import("../Target-B7Yt6pWS.js")), xe = o(async () => import("../TennisBall-6JJbUyOB.js")), Ee = o(async () => import("../Trophy-C4FxiCIO.js")), Ge = o(async () => import("../Volleyball-DlHMDq03.js")), We = o(async () => import("../Activity-fZjlBK1l.js")), Oe = o(async () => import("../Bandaids-DjhwerJf.js")), qe = o(async () => import("../Barbell-CsclAULP.js")), Ie = o(async () => import("../Bed-BHhKq1og.js")), Ve = o(async () => import("../Brain-BNKREHMN.js")), ze = o(async () => import("../FaceMask-C4kBXWwX.js")), Xe = o(async () => import("../FirstAid-C26ulywQ.js")), Ke = o(async () => import("../FirstAidKit-DUzWH5-D.js")), je = o(async () => import("../Flask-CyY6_qIH.js")), Je = o(async () => import("../HandSoap-CAbyX-BV.js")), Ze = o(async () => import("../Heartbeat-jAnHniiF.js")), Qe = o(async () => import("../Lifebuoy-B9lvj0Pf.js")), _e = o(async () => import("../Pill-buFWjFi5.js")), Ye = o(async () => import("../Prescription-Bj13uzp3.js")), $e = o(async () => import("../Syringe-m7aBOA9D.js")), oy = o(async () => import("../TestTube-BSMV6q1Y.js")), ty = o(async () => import("../Toilet-W8qX4Ewh.js")), ny = o(async () => import("../ToiletPaper-tvu1KHvl.js")), sy = o(async () => import("../Airplane-BoI5knpL.js")), cy = o(async () => import("../AirplaneInFlight-Cxfk9C2n.js")), ry = o(async () => import("../AirplaneLanding-yaLrYzI_.js")), iy = o(async () => import("../AirplaneTakeoff-BNfrBmGi.js")), ay = o(async () => import("../AirplaneTilt-B2d1VwM-.js")), py = o(async () => import("../Anchor-CWsIOa1Q.js")), my = o(async () => import("../AnchorSimple-CO1YKxxE.js")), ey = o(async () => import("../Barricade-CgywQ3R1.js")), yy = o(async () => import("../Bicycle-DMvkyKKm.js")), ly = o(async () => import("../Boat-CCgyAc1v.js")), uy = o(async () => import("../Bus-CL30lULc.js")), gy = o(async () => import("../Car-D74ONl0p.js")), Sy = o(async () => import("../CarSimple-CJfCzh4f.js")), Cy = o(async () => import("../Compass-DpRb1-gJ.js")), hy = o(async () => import("../Crosshair-erB1t0I2.js")), dy = o(async () => import("../CrosshairSimple-BCkx7mEa.js")), wy = o(async () => import("../Door-D8EnzxDZ.js")), Ay = o(async () => import("../Flag-RjFXsetl.js")), Ly = o(async () => import("../FlagBanner-DzYKZDjr.js")), ky = o(async () => import("../FlagCheckered-BBCCsk3I.js")), Py = o(async () => import("../GasPump-DvlgeT5T.js")), Fy = o(async () => import("../Globe-B3Xk35A0.js")), by = o(async () => import("../GlobeHemisphereEast-By_d97FN.js")), Ty = o(async () => import("../GlobeHemisphereWest-zilZ2Hi_.js")), By = o(async () => import("../GlobeSimple-Q6tRz3u9.js")), fy = o(async () => import("../GlobeStand-DTvcNUAj.js")), Dy = o(async () => import("../Headlights-CJVg1d6o.js")), Ry = o(async () => import("../House-BeAYQGuN.js")), Hy = o(async () => import("../HouseLine-BVBGE9tS.js")), My = o(async () => import("../HouseSimple-CQNlEt6Y.js")), Uy = o(async () => import("../Jeep-FqR7SLWK.js")), Ny = o(async () => import("../MapPin-BIhCDCyq.js")), vy = o(async () => import("../MapPinLine-CqbgHPdS.js")), xy = o(async () => import("../MapTrifold-Dtm1-7f-.js")), Ey = o(async () => import("../NavigationArrow-DkGCvYQj.js")), Gy = o(async () => import("../Path-BpaVZjP8.js")), Wy = o(async () => import("../PoliceCar-BdLYGyjA.js")), Oy = o(async () => import("../Rocket-DTcpiML0.js")), qy = o(async () => import("../RocketLaunch-BLndFk4t.js")), Iy = o(async () => import("../Signpost-rLlRN0W6.js")), Vy = o(async () => import("../Suitcase-BITzXoUe.js")), zy = o(async () => import("../SuitcaseSimple-NPGR-5nk.js")), Xy = o(async () => import("../Taxi-BU80vINQ.js")), Ky = o(async () => import("../TrafficCone-CXhUTOxV.js")), jy = o(async () => import("../TrafficSign-Dqcfomw8.js")), Jy = o(async () => import("../TrafficSignal-DJQ1u_AM.js")), Zy = o(async () => import("../Train-CSGJS9Fu.js")), Qy = o(async () => import("../TrainRegional-IbDSfCG1.js")), _y = o(async () => import("../TrainSimple-Hs5MXUTB.js")), Yy = o(async () => import("../Truck-1CBN_Qoy.js")), $y = o(async () => import("../Bank-Cd3bDGPP.js")), ol = o(async () => import("../Calculator-BYUux0ag.js")), tl = o(async () => import("../ChartBar-lnffB9Nn.js")), nl = o(async () => import("../ChartBarHorizontal-D_GTmvNB.js")), sl = o(async () => import("../ChartLine-yJpwV3mB.js")), cl = o(async () => import("../ChartLineUp-CPxW14Mo.js")), rl = o(async () => import("../ChartPie-DUQfBR_e.js")), il = o(async () => import("../ChartPieSlice-CqUpzHfX.js")), al = o(async () => import("../Divide-DvWGig8o.js")), pl = o(async () => import("../Equals-id7zXai3.js")), ml = o(async () => import("../Function-DkzgANxp.js")), el = o(async () => import("../Graph-ydwReb62.js")), yl = o(async () => import("../Infinity-DMLycqqm.js")), ll = o(async () => import("../MathOperations-iqZCrnTm.js")), ul = o(async () => import("../Minus-C5VwDp6Q.js")), gl = o(async () => import("../MinusCircle-BofICE1S.js")), Sl = o(async () => import("../NumberCircleEight-CnH6UGGC.js")), Cl = o(async () => import("../NumberCircleFive-BtJ7uFKf.js")), hl = o(async () => import("../NumberCircleFour-ecErYknz.js")), dl = o(async () => import("../NumberCircleNine-BrUK3vtL.js")), wl = o(async () => import("../NumberCircleOne-CiNyVPRw.js")), Al = o(async () => import("../NumberCircleSeven-8brPXBJp.js")), Ll = o(async () => import("../NumberCircleSix-MQWHEa3I.js")), kl = o(async () => import("../NumberCircleThree-YGdVjdbD.js")), Pl = o(async () => import("../NumberCircleTwo-MsZWZOZN.js")), Fl = o(async () => import("../NumberCircleZero-CLanl-XR.js")), bl = o(async () => import("../NumberEight-BwK5mV0n.js")), Tl = o(async () => import("../NumberFive-UuWh_mmH.js")), Bl = o(async () => import("../NumberFour-4XzASnUn.js")), fl = o(async () => import("../NumberNine-C4c0X2HE.js")), Dl = o(async () => import("../NumberOne-nBlxGGxm.js")), Rl = o(async () => import("../NumberSeven-Cfw9n6pV.js")), Hl = o(async () => import("../NumberSix-TV7UiKNK.js")), Ml = o(async () => import("../NumberSquareEight-BHec3B0k.js")), Ul = o(async () => import("../NumberSquareFive-BYfBwGfg.js")), Nl = o(async () => import("../NumberSquareFour-31D2KyNz.js")), vl = o(async () => import("../NumberSquareNine-BzNJfNo8.js")), xl = o(async () => import("../NumberSquareOne-Df1om3Pp.js")), El = o(async () => import("../NumberSquareSeven-B-ca94xC.js")), Gl = o(async () => import("../NumberSquareSix-d8oDpnm3.js")), Wl = o(async () => import("../NumberSquareThree-DV2WGOVF.js")), Ol = o(async () => import("../NumberSquareTwo-g7HhgcSN.js")), ql = o(async () => import("../NumberSquareZero-CTxVaWZ6.js")), Il = o(async () => import("../NumberThree-DHM24ajO.js")), Vl = o(async () => import("../NumberTwo-Ty_DbBz3.js")), zl = o(async () => import("../NumberZero-BoQJI_eV.js")), Xl = o(async () => import("../Percent-iFVr9IAa.js")), Kl = o(async () => import("../Plus-uVlAc42M.js")), jl = o(async () => import("../PlusCircle-C9OhQgww.js")), Jl = o(async () => import("../PlusMinus-BoUQW4Xy.js")), Zl = o(async () => import("../Radical-DAsbLhCE.js")), Ql = o(async () => import("../Table-C2jxLH1_.js")), _l = o(async () => import("../TrendDown-Dk8whoDR.js")), Yl = o(async () => import("../TrendUp-DYIWlRNe.js")), $l = o(async () => import("../X-B2DEccRQ.js")), ou = o(async () => import("../XCircle-ZZMmda4Q.js")), tu = o(async () => import("../XSquare-BtxGKtd0.js")), nu = o(async () => import("../Airplay-Yjo33YDN.js")), su = o(async () => import("../Aperture-Xvex9ID1.js")), cu = o(async () => import("../Article-X827e6Q2.js")), ru = o(async () => import("../ArticleMedium-D-zQ47d-.js")), iu = o(async () => import("../ArticleNyTimes-C6zYF7zB.js")), au = o(async () => import("../Camera-CQYIH6fK.js")), pu = o(async () => import("../CameraRotate-DSritxlD.js")), mu = o(async () => import("../CameraSlash-6OeAKwCH.js")), eu = o(async () => import("../ClosedCaptioning-a0FWoL9G.js")), yu = o(async () => import("../Copyleft-DKBCgtcL.js")), lu = o(async () => import("../Copyright-Dzoqv0EV.js")), uu = o(async () => import("../CornersIn-DOfa4GMZ.js")), gu = o(async () => import("../CornersOut-QqySuFIv.js")), Su = o(async () => import("../Disc-LjqhQopv.js")), Cu = o(async () => import("../Ear-7O6p2ixC.js")), hu = o(async () => import("../EarSlash-Ct67ZzfR.js")), du = o(async () => import("../Eject-DB3w7GLd.js")), wu = o(async () => import("../EjectSimple-n2wPif_Y.js")), Au = o(async () => import("../Equalizer-DY5F8k9_.js")), Lu = o(async () => import("../Faders-Wii15qW_.js")), ku = o(async () => import("../FadersHorizontal-DYU2wrFW.js")), Pu = o(async () => import("../FastForward-D9waKEU5.js")), Fu = o(async () => import("../FastForwardCircle-C-BOKRAm.js")), bu = o(async () => import("../FilmScript-DpDUNf8X.js")), Tu = o(async () => import("../FilmSlate-B3q4-aP3.js")), Bu = o(async () => import("../FilmStrip-CiCLr4M5.js")), fu = o(async () => import("../FrameCorners-FCrf7_tI.js")), Du = o(async () => import("../Gif-DPg_f6sC.js")), Ru = o(async () => import("../Headphones-CBiRkZYN.js")), Hu = o(async () => import("../Headset-DhAuToSZ.js")), Mu = o(async () => import("../Image-Bl2Qwv30.js")), Uu = o(async () => import("../ImageSquare-Kd5N4zQj.js")), Nu = o(async () => import("../Microphone-WOWkIkAH.js")), vu = o(async () => import("../MicrophoneSlash-KJaTCbN4.js")), xu = o(async () => import("../MicrophoneStage-axTZMTjs.js")), Eu = o(async () => import("../MusicNote-BKaITbSy.js")), Gu = o(async () => import("../MusicNotes-BcB3Lv7G.js")), Wu = o(async () => import("../MusicNoteSimple-ChGFEU9W.js")), Ou = o(async () => import("../MusicNotesPlus-CMgNUQh2.js")), qu = o(async () => import("../MusicNotesSimple-DF8xoQDl.js")), Iu = o(async () => import("../Newspaper-Dx2RDca8.js")), Vu = o(async () => import("../NewspaperClipping-Tq1nTJt_.js")), zu = o(async () => import("../Pause-B54mq2nS.js")), Xu = o(async () => import("../PauseCircle-BkU-0AzY.js")), Ku = o(async () => import("../PianoKeys-rokzL_Am.js")), ju = o(async () => import("../PictureInPicture-DtKzY8eV.js")), Ju = o(async () => import("../Play-BFi6vfhv.js")), Zu = o(async () => import("../PlayCircle-B3z8U3Me.js")), Qu = o(async () => import("../Playlist-DUKSmy6T.js")), _u = o(async () => import("../Queue-CNWVNdQw.js")), Yu = o(async () => import("../Record-8xeGaRCl.js")), $u = o(async () => import("../Repeat-D8IukqTV.js")), og = o(async () => import("../RepeatOnce-DU2BX0rR.js")), tg = o(async () => import("../Rewind-CSzHg0OM.js")), ng = o(async () => import("../RewindCircle-CABa6qJq.js")), sg = o(async () => import("../Screencast-BoxPj8Rf.js")), cg = o(async () => import("../Shuffle-Dlfw5rEA.js")), rg = o(async () => import("../ShuffleAngular-BowhKzFX.js")), ig = o(async () => import("../ShuffleSimple-_V-Y0nc_.js")), ag = o(async () => import("../SkipBack-BJsGJLmt.js")), pg = o(async () => import("../SkipBackCircle-JG1Hi3-Q.js")), mg = o(async () => import("../SkipForward-BVR_gLm8.js")), eg = o(async () => import("../SkipForwardCircle-Cp6VPjEi.js")), yg = o(async () => import("../Sliders-3f1cYZwO.js")), lg = o(async () => import("../SlidersHorizontal-DLAE1Hqk.js")), ug = o(async () => import("../SpeakerHigh-BOreC0GX.js")), gg = o(async () => import("../SpeakerLow-BXs2o70c.js")), Sg = o(async () => import("../SpeakerNone-B9lcj9u2.js")), Cg = o(async () => import("../SpeakerSimpleHigh-CBW5Ebys.js")), hg = o(async () => import("../SpeakerSimpleLow-DfMAroHS.js")), dg = o(async () => import("../SpeakerSimpleNone-DuxhwRt3.js")), wg = o(async () => import("../SpeakerSimpleSlash-BRBcLFlW.js")), Ag = o(async () => import("../SpeakerSimpleX-B4tDoQeW.js")), Lg = o(async () => import("../SpeakerSlash-BU5WdpG4.js")), kg = o(async () => import("../SpeakerX-CrxRZJqY.js")), Pg = o(async () => import("../Stop-C3QJu4OC.js")), Fg = o(async () => import("../StopCircle-Df0b_HFy.js")), bg = o(async () => import("../Television-IbOYNzc8.js")), Tg = o(async () => import("../TelevisionSimple-xjS2STBf.js")), Bg = o(async () => import("../VideoCamera-DQwQLBn9.js")), fg = o(async () => import("../VideoCameraSlash-CM_YVfGT.js")), Dg = o(async () => import("../WaveSawtooth-B7GSv7xV.js")), Rg = o(async () => import("../WaveSine-Ci1Pc7Xp.js")), Hg = o(async () => import("../WaveSquare-OTxjGt9L.js")), Mg = o(async () => import("../WaveTriangle-2JxJedun.js")), Ug = o(async () => import("../Webcam-Bo4h4I9a.js")), Ng = o(async () => import("../Archive-BRq6_S2c.js")), vg = o(async () => import("../ArchiveBox-D_07wGgi.js")), xg = o(async () => import("../ArchiveTray-B3RvEPJI.js")), Eg = o(async () => import("../Briefcase-BN8T9ErY.js")), Gg = o(async () => import("../BriefcaseMetal-cXNkByd3.js")), Wg = o(async () => import("../Cards-VZCWurvE.js")), Og = o(async () => import("../Clipboard-SvX2APHU.js")), qg = o(async () => import("../ClipboardText-CIJi46gJ.js")), Ig = o(async () => import("../Copy-DNwPuHsj.js")), Vg = o(async () => import("../CopySimple-CWxX4Yg6.js")), zg = o(async () => import("../CursorText-Cn_v3N9S.js")), Xg = o(async () => import("../File-Dl8HJc3K.js")), Kg = o(async () => import("../FileArrowDown-4twRvCVb.js")), jg = o(async () => import("../FileArrowUp-DWOP40x6.js")), Jg = o(async () => import("../FileAudio-BqxtzZmE.js")), Zg = o(async () => import("../FileCloud-Dpea3pK8.js")), Qg = o(async () => import("../FileCode-BgGpP1qL.js")), _g = o(async () => import("../FileCss-CyB3K_VX.js")), Yg = o(async () => import("../FileCsv-B0HFGSax.js")), $g = o(async () => import("../FileDoc-CsVkRBg_.js")), oS = o(async () => import("../FileDotted-D8l6tMm2.js")), tS = o(async () => import("../FileHtml-BdTjmR1w.js")), nS = o(async () => import("../FileImage-Bphhnw9K.js")), sS = o(async () => import("../FileJpg-lhMLzyo-.js")), cS = o(async () => import("../FileJs-DDBCZKvT.js")), rS = o(async () => import("../FileJsx-C9hl-h1l.js")), iS = o(async () => import("../FileLock-BGC3PGee.js")), aS = o(async () => import("../FileMinus-Fkd_5b54.js")), pS = o(async () => import("../FilePdf-WttZ5nD5.js")), mS = o(async () => import("../FilePlus-CyHvvI0Q.js")), eS = o(async () => import("../FilePng-Bqnj0DE2.js")), yS = o(async () => import("../FilePpt-CSMoykik.js")), lS = o(async () => import("../FileRs-rg2KJFBT.js")), uS = o(async () => import("../Files-o3Ar9fqp.js")), gS = o(async () => import("../FileSearch-CEv2Djb0.js")), SS = o(async () => import("../FileText-Ba_KuDg7.js")), CS = o(async () => import("../FileTs-CCuX5I-4.js")), hS = o(async () => import("../FileTsx-Dlem0FBX.js")), dS = o(async () => import("../FileVideo-B_cAzEJM.js")), wS = o(async () => import("../FileVue-BNsWu1AX.js")), AS = o(async () => import("../FileX-DvtCx7-F.js")), LS = o(async () => import("../FileXls-Ur_W3xg9.js")), kS = o(async () => import("../FileZip-Cmxqv9Tf.js")), PS = o(async () => import("../FloppyDisk-CPwmfFWJ.js")), FS = o(async () => import("../FloppyDiskBack-DyEp1w8p.js")), bS = o(async () => import("../Folder-BbVQb_r7.js")), TS = o(async () => import("../FolderDotted-BbKOAK2k.js")), BS = o(async () => import("../FolderLock-CwnZRNcI.js")), fS = o(async () => import("../FolderMinus-BdPScMhl.js")), DS = o(async () => import("../FolderNotch-0ntX3W-z.js")), RS = o(async () => import("../FolderNotchMinus-DVpubIPL.js")), HS = o(async () => import("../FolderNotchOpen-BUztyE-U.js")), MS = o(async () => import("../FolderNotchPlus-BhlTpFFw.js")), US = o(async () => import("../FolderOpen-9O9wS-vh.js")), NS = o(async () => import("../FolderPlus-CrQdI2ip.js")), vS = o(async () => import("../Folders-JSKrPNU5.js")), xS = o(async () => import("../FolderSimple-DtDwU38w.js")), ES = o(async () => import("../FolderSimpleDotted-BNeQKV0X.js")), GS = o(async () => import("../FolderSimpleLock-nRaxXSEn.js")), WS = o(async () => import("../FolderSimpleMinus-CqFpnGSa.js")), OS = o(async () => import("../FolderSimplePlus-BFrybvXZ.js")), qS = o(async () => import("../FolderSimpleStar-Dvdxq53V.js")), IS = o(async () => import("../FolderSimpleUser-CAtpz_W2.js")), VS = o(async () => import("../FolderStar-C0XJZxuV.js")), zS = o(async () => import("../FolderUser-e7jtm54z.js")), XS = o(async () => import("../Funnel-B6r_UKPh.js")), KS = o(async () => import("../FunnelSimple-CQ_zEHsh.js")), jS = o(async () => import("../Kanban-CYEnjckV.js")), JS = o(async () => import("../List-DD3VuwhG.js")), ZS = o(async () => import("../ListBullets-C3WREteP.js")), QS = o(async () => import("../ListChecks-uwmih6qr.js")), _S = o(async () => import("../ListDashes-CPs1Ttrg.js")), YS = o(async () => import("../ListNumbers-BZih1TTu.js")), $S = o(async () => import("../ListPlus-CuAkTdMl.js")), oC = o(async () => import("../Note-DQ9ho8oV.js")), tC = o(async () => import("../NoteBlank-Bg4ObOGk.js")), nC = o(async () => import("../Notebook-BFWOBbjH.js")), sC = o(async () => import("../Notepad-CwoDpPUr.js")), cC = o(async () => import("../NotePencil-C7jvO8el.js")), rC = o(async () => import("../Paperclip-BkcSPgzc.js")), iC = o(async () => import("../PaperclipHorizontal-Ce5XUmwm.js")), aC = o(async () => import("../Presentation-B2Ru-2Dp.js")), pC = o(async () => import("../PresentationChart-D4QXcn_n.js")), mC = o(async () => import("../Printer-mdanItzl.js")), eC = o(async () => import("../ProjectorScreen-CHht4cCi.js")), yC = o(async () => import("../ProjectorScreenChart-CmJ3NCCM.js")), lC = o(async () => import("../PushPin-mkdy_FBE.js")), uC = o(async () => import("../PushPinSimple-Dx1ze5GD.js")), gC = o(async () => import("../PushPinSimpleSlash-6mtFObkM.js")), SC = o(async () => import("../PushPinSlash-B5mr2ALn.js")), CC = o(async () => import("../SortAscending-BYpdjA-Y.js")), hC = o(async () => import("../SortDescending-BMBGS8G0.js")), dC = o(async () => import("../TextAa-C6Q89Icu.js")), wC = o(async () => import("../TextAlignCenter-BMUyNG2F.js")), AC = o(async () => import("../TextAlignJustify-3fQoMo51.js")), LC = o(async () => import("../TextAlignLeft-CwiRUxWd.js")), kC = o(async () => import("../TextAlignRight-WfYSY6yu.js")), PC = o(async () => import("../TextBolder-BasAzQFr.js")), FC = o(async () => import("../Textbox-dReiuDHU.js")), bC = o(async () => import("../TextH-CCZbeNqw.js")), TC = o(async () => import("../TextHFive-DJQszQFD.js")), BC = o(async () => import("../TextHFour-BGW43SG2.js")), fC = o(async () => import("../TextHOne-Dx3llKvq.js")), DC = o(async () => import("../TextHSix-DZqG89yQ.js")), RC = o(async () => import("../TextHThree-BFvYOKqt.js")), HC = o(async () => import("../TextHTwo-Pq9HczIM.js")), MC = o(async () => import("../TextIndent-BvXGgav9.js")), UC = o(async () => import("../TextItalic-DFc0W6zn.js")), NC = o(async () => import("../TextOutdent-sMQOAUQb.js")), vC = o(async () => import("../TextStrikethrough-ulHZrsMc.js")), xC = o(async () => import("../TextT-DnIX3VlU.js")), EC = o(async () => import("../TextUnderline-CALnlhyS.js")), GC = o(async () => import("../Trash-C2u6AHxW.js")), WC = o(async () => import("../TrashSimple-BZwFezlf.js")), OC = o(async () => import("../Tray-BGFNpTA9.js")), qC = o(async () => import("../Baby-CfFKUkh3.js")), IC = o(async () => import("../GenderFemale-BLsqZfsP.js")), VC = o(async () => import("../GenderIntersex-D4w3-yOY.js")), zC = o(async () => import("../GenderMale-BuP27Y9e.js")), XC = o(async () => import("../GenderNeuter-E2_ZoOJg.js")), KC = o(async () => import("../GenderNonbinary-DTbK4JSa.js")), jC = o(async () => import("../GenderTransgender-CN-DvkwX.js")), JC = o(async () => import("../Hand-zB-Wzc5o.js")), ZC = o(async () => import("../HandEye-hh3rTHTy.js")), QC = o(async () => import("../HandFist-DXjPibTT.js")), _C = o(async () => import("../HandGrabbing-BCv229lg.js")), YC = o(async () => import("../HandPalm-Cu0sxWvo.js")), $C = o(async () => import("../HandPointing-19uUj5N6.js")), oh = o(async () => import("../HandsClapping-Bb03vM-I.js")), th = o(async () => import("../Handshake-yvyYooqe.js")), nh = o(async () => import("../HandWaving-BOP8McqS.js")), sh = o(async () => import("../IdentificationBadge-BZrxclZc.js")), ch = o(async () => import("../IdentificationCard-C4V38Ti1.js")), rh = o(async () => import("../Person-B0WMqWFB.js")), ih = o(async () => import("../PersonSimple-DIzY1t1U.js")), ah = o(async () => import("../PersonSimpleRun-AE4VVTFT.js")), ph = o(async () => import("../PersonSimpleWalk-B6GRHbVo.js")), mh = o(async () => import("../Smiley-Bcm4D5Ew.js")), eh = o(async () => import("../SmileyBlank-DTh_TIKj.js")), yh = o(async () => import("../SmileyMeh-DSphD0jv.js")), lh = o(async () => import("../SmileyNervous-hFgXvf7n.js")), uh = o(async () => import("../SmileySad-Es-M1q7G.js")), gh = o(async () => import("../SmileySticker-qEhaQbYR.js")), Sh = o(async () => import("../SmileyWink-DfU6czPx.js")), Ch = o(async () => import("../SmileyXEyes-DthjaPK4.js")), hh = o(async () => import("../User-El5ij6jA.js")), dh = o(async () => import("../UserCircle-DW56ekcm.js")), wh = o(async () => import("../UserCircleGear-9h8BtiYU.js")), Ah = o(async () => import("../UserCircleMinus-BYcWjXL2.js")), Lh = o(async () => import("../UserCirclePlus-BKG7l9Gq.js")), kh = o(async () => import("../UserFocus-CmSPc_nx.js")), Ph = o(async () => import("../UserGear-DrdMtaO_.js")), Fh = o(async () => import("../UserList-Chm_JT_u.js")), bh = o(async () => import("../UserMinus--31FcHDv.js")), Th = o(async () => import("../UserPlus-D6vcjqSf.js")), Bh = o(async () => import("../UserRectangle-CY6LzK-b.js")), fh = o(async () => import("../Users-Brezfh4c.js")), Dh = o(async () => import("../UsersFour-dW88F9Rk.js")), Rh = o(async () => import("../UserSquare-D45_0ElN.js")), Hh = o(async () => import("../UsersThree-Bfy4kUbI.js")), Mh = o(async () => import("../UserSwitch-Ds8jb389.js")), Uh = o(async () => import("../Wheelchair-D4btvJb3.js")), Nh = o(async () => import("../CircleWavy-DN8jZI-A.js")), vh = o(async () => import("../CircleWavyCheck-of4jR3f_.js")), xh = o(async () => import("../CircleWavyQuestion-c_Dfko_m.js")), Eh = o(async () => import("../CircleWavyWarning-BdguPv2G.js")), Gh = o(async () => import("../Detective-DayRoAdQ.js")), Wh = o(async () => import("../Fingerprint-PvUU2aKP.js")), Oh = o(async () => import("../FingerprintSimple-DH9f0lHn.js")), qh = o(async () => import("../Info-CgXlccz8.js")), Ih = o(async () => import("../Key-K-WMBctK.js")), Vh = o(async () => import("../Keyhole-V1SAxOV5.js")), zh = o(async () => import("../Lock-CAmeOwoz.js")), Xh = o(async () => import("../LockKey-CJrhTHBg.js")), Kh = o(async () => import("../LockKeyOpen-CS4gGG_x.js")), jh = o(async () => import("../LockLaminated-DuSza2ug.js")), Jh = o(async () => import("../LockLaminatedOpen-C89o9ikr.js")), Zh = o(async () => import("../LockOpen-CKA5J5gi.js")), Qh = o(async () => import("../LockSimple-D9qRW5A3.js")), _h = o(async () => import("../LockSimpleOpen-fF9-WEKI.js")), Yh = o(async () => import("../Password-DXCyk9vm.js")), $h = o(async () => import("../Prohibit-D_dq3eFJ.js")), od = o(async () => import("../ProhibitInset-DohmSatB.js")), td = o(async () => import("../Question-znrifemS.js")), nd = o(async () => import("../Shield-rgLc5jqG.js")), sd = o(async () => import("../ShieldCheck-BEiSCj_4.js")), cd = o(async () => import("../ShieldCheckered-CKAk1F1g.js")), rd = o(async () => import("../ShieldChevron-DSoqffG6.js")), id = o(async () => import("../ShieldPlus-Chn0ar3X.js")), ad = o(async () => import("../ShieldSlash-CqZqsX-t.js")), pd = o(async () => import("../ShieldStar-DwmAZfzM.js")), md = o(async () => import("../ShieldWarning-DUVZuzn8.js")), ed = o(async () => import("../Vault-K7_oOaE-.js")), yd = o(async () => import("../Wall-89k9tqnu.js")), ld = o(async () => import("../Warning-Tmqi-uNq.js")), ud = o(async () => import("../WarningCircle-CBXfrZDx.js")), gd = o(async () => import("../WarningOctagon-CgpQV0zN.js")), Sd = o(async () => import("../AppWindow-B1ZW8r7L.js")), Cd = o(async () => import("../Backspace-BX5byCWc.js")), hd = o(async () => import("../BatteryCharging-Bo7tNYMh.js")), dd = o(async () => import("../BatteryChargingVertical-DYtCSVlQ.js")), wd = o(async () => import("../BatteryEmpty-y9gCfMb1.js")), Ad = o(async () => import("../BatteryFull-BMbXkXYM.js")), Ld = o(async () => import("../BatteryHigh-BZEFzdBS.js")), kd = o(async () => import("../BatteryLow-Bft6FApC.js")), Pd = o(async () => import("../BatteryMedium-tIlPGYu_.js")), Fd = o(async () => import("../BatteryPlus-CSkAxTb6.js")), bd = o(async () => import("../BatteryWarning-BI5yo5dM.js")), Td = o(async () => import("../BatteryWarningVertical-DIyZ0WnA.js")), Bd = o(async () => import("../Bell-31q7zrYy.js")), fd = o(async () => import("../BellRinging-upeCoiJE.js")), Dd = o(async () => import("../BellSimple-BczXmguK.js")), Rd = o(async () => import("../BellSimpleRinging-BxtEx9OL.js")), Hd = o(async () => import("../BellSimpleSlash-BpMWy2a5.js")), Md = o(async () => import("../BellSimpleZ-DaRBo4nD.js")), Ud = o(async () => import("../BellSlash-BUUNFU3X.js")), Nd = o(async () => import("../BellZ-BqhUHCnA.js")), vd = o(async () => import("../Bluetooth-Cdtilxf-.js")), xd = o(async () => import("../BluetoothConnected-BNzeNA1e.js")), Ed = o(async () => import("../BluetoothSlash-DHeMVpgv.js")), Gd = o(async () => import("../BluetoothX-ylNZwNgU.js")), Wd = o(async () => import("../Browser-B1J5wLhf.js")), Od = o(async () => import("../Browsers-Cw5cQrAI.js")), qd = o(async () => import("../CellSignalFull-DdQr1uUu.js")), Id = o(async () => import("../CellSignalHigh-BmtwQ0by.js")), Vd = o(async () => import("../CellSignalLow-Dm6X2c6t.js")), zd = o(async () => import("../CellSignalMedium-BrL4WbN1.js")), Xd = o(async () => import("../CellSignalNone-Vy9l0P8p.js")), Kd = o(async () => import("../CellSignalSlash-C7biw0kz.js")), jd = o(async () => import("../CellSignalX-DnM-SDTh.js")), Jd = o(async () => import("../Check-Bab2zyk_.js")), Zd = o(async () => import("../CheckCircle-DYUzAAWi.js")), Qd = o(async () => import("../Checks-Bed-nSoN.js")), _d = o(async () => import("../CheckSquare-Bs_dGcCh.js")), Yd = o(async () => import("../CheckSquareOffset-xvYIOT2b.js")), $d = o(async () => import("../CloudArrowDown-_FOnny0D.js")), ow = o(async () => import("../CloudArrowUp-BTXORaYo.js")), tw = o(async () => import("../CloudCheck-yevXdvgO.js")), nw = o(async () => import("../CloudSlash-zRmOzAN6.js")), sw = o(async () => import("../Command-CKZLln0U.js")), cw = o(async () => import("../ComputerTower-BFa8ylmC.js")), rw = o(async () => import("../Cursor-zaijkk58.js")), iw = o(async () => import("../Desktop-D7rz4aQj.js")), aw = o(async () => import("../DesktopTower-CCAppbzy.js")), pw = o(async () => import("../DeviceMobile-VfeSuJGk.js")), mw = o(async () => import("../DeviceMobileCamera-Cab61-ID.js")), ew = o(async () => import("../DeviceMobileSpeaker-CMkQC_gl.js")), yw = o(async () => import("../DeviceTablet-Cda8KzHU.js")), lw = o(async () => import("../DeviceTabletCamera-vVf09QGO.js")), uw = o(async () => import("../DeviceTabletSpeaker-Dvojr04z.js")), gw = o(async () => import("../DotsNine-DuQ6s1PT.js")), Sw = o(async () => import("../DotsSix-D6xGCuzJ.js")), Cw = o(async () => import("../DotsSixVertical-Dz1z4GK2.js")), hw = o(async () => import("../DotsThree-Bksu8Ljr.js")), dw = o(async () => import("../DotsThreeCircle-DQLw0TMz.js")), ww = o(async () => import("../DotsThreeCircleVertical-4eEp9UYJ.js")), Aw = o(async () => import("../DotsThreeOutline-BjXl70LT.js")), Lw = o(async () => import("../DotsThreeOutlineVertical-CHAOdDa3.js")), kw = o(async () => import("../DotsThreeVertical-OleXNkrV.js")), Pw = o(async () => import("../Download-BfDA5pRf.js")), Fw = o(async () => import("../DownloadSimple-BTefayx_.js")), bw = o(async () => import("../Flashlight-BEAQ82kE.js")), Tw = o(async () => import("../Gauge-UTHA4MSM.js")), Bw = o(async () => import("../Gear-DnnweHPp.js")), fw = o(async () => import("../GearSix-Dt4o2lTA.js")), Dw = o(async () => import("../HardDrive-DC33KOLa.js")), Rw = o(async () => import("../HardDrives-DKjjfCKX.js")), Hw = o(async () => import("../Keyboard-CdIjtKyv.js")), Mw = o(async () => import("../KeyReturn-9GxH7d0L.js")), Uw = o(async () => import("../Laptop-bfWbzW8a.js")), Nw = o(async () => import("../Lightbulb-CCaA2jrw.js")), vw = o(async () => import("../LightbulbFilament-CWktCv0x.js")), xw = o(async () => import("../Lightning-Dhq75G3F.js")), Ew = o(async () => import("../LightningSlash-B2k1JoX2.js")), Gw = o(async () => import("../Link-_eSc9Cy4.js")), Ww = o(async () => import("../LinkBreak-DLP_DOYr.js")), Ow = o(async () => import("../LinkSimple-DTHNzy6P.js")), qw = o(async () => import("../LinkSimpleBreak-ABwAkWuX.js")), Iw = o(async () => import("../LinkSimpleHorizontal-DzJYmk1V.js")), Vw = o(
  async () => import("../LinkSimpleHorizontalBreak-BATzp3pX.js")
), zw = o(async () => import("../MagnifyingGlass-CxE1-oVS.js")), Xw = o(async () => import("../MagnifyingGlassMinus-dy1KzbDM.js")), Kw = o(async () => import("../MagnifyingGlassPlus-BtxfSEXu.js")), jw = o(async () => import("../Monitor-DL2U33eq.js")), Jw = o(async () => import("../MonitorPlay-DlkTY2Br.js")), Zw = o(async () => import("../Mouse-D-gwqSYF.js")), Qw = o(async () => import("../MouseSimple-CRlx0ivN.js")), _w = o(async () => import("../Notification-BLyS_xWv.js")), Yw = o(async () => import("../Nut-C7TXQRe9.js")), $w = o(async () => import("../Option-o3ysVkYP.js")), oA = o(async () => import("../Plug-CKo7tjeX.js")), tA = o(async () => import("../Plugs-CHnTdVNT.js")), nA = o(async () => import("../PlugsConnected-BsQc7MFb.js")), sA = o(async () => import("../Power-C5QnW7kl.js")), cA = o(async () => import("../QrCode-CnbtmP2y.js")), rA = o(async () => import("../RadioButton-CrZ2Xiz6.js")), iA = o(async () => import("../Scan-fm8KTtek.js")), aA = o(async () => import("../SignIn-B9u_oHOH.js")), pA = o(async () => import("../SignOut-DAlQJCgS.js")), mA = o(async () => import("../SimCard-w1NZl4Oa.js")), eA = o(async () => import("../Spinner-B1I2_JN1.js")), yA = o(async () => import("../SpinnerGap-Cn0ZiMN6.js")), lA = o(async () => import("../Swap-o3NpdqrM.js")), uA = o(async () => import("../Tabs-dty7NQLw.js")), gA = o(async () => import("../ToggleLeft-DzpMYtiq.js")), SA = o(async () => import("../ToggleRight-KglLMPvw.js")), CA = o(async () => import("../Upload-BBmwtW6q.js")), hA = o(async () => import("../UploadSimple-DRRkZqO6.js")), dA = o(async () => import("../Vibrate-BDIKpXFd.js")), wA = o(async () => import("../WifiHigh-DTlHy4Ol.js")), AA = o(async () => import("../WifiLow-EsJGEioq.js")), LA = o(async () => import("../WifiMedium-CkfDX538.js")), kA = o(async () => import("../WifiNone-uCBB9FiQ.js")), PA = o(async () => import("../WifiSlash-Cwdly3UK.js")), FA = o(async () => import("../WifiX-COrK_kYA.js")), bA = o(async () => import("../Wrench-CdcCEjKS.js")), TA = o(async () => import("../Alarm-ZgxvYEMs.js")), BA = o(async () => import("../Calendar-BbV8bfK0.js")), fA = o(async () => import("../CalendarBlank-C-Ylnb8O.js")), DA = o(async () => import("../CalendarCheck-CeU8sEXA.js")), RA = o(async () => import("../CalendarPlus-B3S3mYfv.js")), HA = o(async () => import("../CalendarX-CmAynN-X.js")), MA = o(async () => import("../Clock-DFVkyvKa.js")), UA = o(async () => import("../ClockAfternoon-D4OqO7ga.js")), NA = o(async () => import("../ClockClockwise-DtuUHaDB.js")), vA = o(async () => import("../ClockCounterClockwise-DbF5v07I.js")), xA = o(async () => import("../Hourglass-B6FhU6Az.js")), EA = o(async () => import("../HourglassHigh-BcZCH1dv.js")), GA = o(async () => import("../HourglassLow-BlUPQPts.js")), WA = o(async () => import("../HourglassMedium-CERdksy9.js")), OA = o(async () => import("../HourglassSimple-BdeozWWR.js")), qA = o(async () => import("../HourglassSimpleHigh-BRSOwLM0.js")), IA = o(async () => import("../HourglassSimpleLow-DpkJgi1B.js")), VA = o(async () => import("../HourglassSimpleMedium-BxsRLngc.js")), zA = o(async () => import("../Timer-SEr1EH8X.js")), XA = o(async () => import("../Watch-Bho_FWIl.js")), KA = o(async () => import("../Atom-Bm0tXBQs.js")), jA = o(async () => import("../Bird-CXBVGWkx.js")), JA = o(async () => import("../Butterfly-B2OslO4w.js")), ZA = o(async () => import("../Cactus-JzsGAFUT.js")), QA = o(async () => import("../Campfire-QoBSm9fb.js")), _A = o(async () => import("../Cat-BYA7xNMN.js")), YA = o(async () => import("../Cloud-B9G5nGgW.js")), $A = o(async () => import("../CloudFog-Dd0xDtat.js")), oL = o(async () => import("../CloudLightning-DY5ksOMg.js")), tL = o(async () => import("../CloudMoon-DKGh4DJP.js")), nL = o(async () => import("../CloudRain-BenANLtK.js")), sL = o(async () => import("../CloudSnow-DGtyKvsl.js")), cL = o(async () => import("../CloudSun-DUrzl8Zk.js")), rL = o(async () => import("../Dog-DpId0jcI.js")), iL = o(async () => import("../Drop-TT1NLiJ6.js")), aL = o(async () => import("../Fire-BT3rVtJ9.js")), pL = o(async () => import("../FireSimple-BZ9_EAnk.js")), mL = o(async () => import("../Fish-fnSQf0IW.js")), eL = o(async () => import("../FishSimple-BUOlXdpg.js")), yL = o(async () => import("../Flame-DgaWVZyD.js")), lL = o(async () => import("../Flower-D8Fx6Mu8.js")), uL = o(async () => import("../FlowerLotus-CgnVA9vg.js")), gL = o(async () => import("../Leaf-Dqmxgstx.js")), SL = o(async () => import("../Moon-Bj2BCV-t.js")), CL = o(async () => import("../MoonStars-T-KCKS8p.js")), hL = o(async () => import("../Mountains-CDP2Hop_.js")), dL = o(async () => import("../PawPrint-DXZWiC4X.js")), wL = o(async () => import("../Planet-cs3RoR3U.js")), AL = o(async () => import("../Rainbow-DTFVlpHf.js")), LL = o(async () => import("../RainbowCloud-BGKRQ9Wz.js")), kL = o(async () => import("../Snowflake-BaL38K4k.js")), PL = o(async () => import("../Sparkle-AKO9xIMp.js")), FL = o(async () => import("../StarFour-NkiBQGsR.js")), bL = o(async () => import("../Sun-uZjW-6yZ.js")), TL = o(async () => import("../SunDim-BXLH4oSU.js")), BL = o(async () => import("../SunHorizon-CAbi3pEH.js")), fL = o(async () => import("../Thermometer-Cy7OYNT6.js")), DL = o(async () => import("../ThermometerCold-ZLkM7ooH.js")), RL = o(async () => import("../ThermometerHot-COjGgcM2.js")), HL = o(async () => import("../ThermometerSimple-V7-71FM1.js")), ML = o(async () => import("../Tree-Dwu3pc7l.js")), UL = o(async () => import("../TreeEvergreen-B5BpIZ7t.js")), NL = o(async () => import("../Umbrella-Cjtj2Hkb.js")), vL = o(async () => import("../UmbrellaSimple-BZeAv6xz.js")), xL = o(async () => import("../Waves-BjHLGK39.js")), EL = o(async () => import("../Wind-DryJjAea.js")), GL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Activity: We,
  AddressBook: Rs,
  Airplane: sy,
  AirplaneInFlight: cy,
  AirplaneLanding: ry,
  AirplaneTakeoff: iy,
  AirplaneTilt: ay,
  Airplay: nu,
  Alarm: TA,
  Alien: _m,
  AlignBottom: Rc,
  AlignBottomSimple: Hc,
  AlignCenter: ji,
  AlignCenterHorizontal: Mc,
  AlignCenterHorizontalSimple: Uc,
  AlignCenterVertical: Nc,
  AlignCenterVerticalSimple: vc,
  AlignJustify: Ji,
  AlignLeft: xc,
  AlignLeftAlt: Zi,
  AlignLeftSimple: Ec,
  AlignRight: Gc,
  AlignRightAlt: Qi,
  AlignRightSimple: Wc,
  AlignTop: Oc,
  AlignTopSimple: qc,
  Anchor: py,
  AnchorSimple: my,
  AndroidLogo: gt,
  AngleArrowDown: _i,
  AngleArrowLeft: Yi,
  AngleArrowRight: $i,
  AngleArrowSmallDown: oa,
  AngleArrowSmallLeft: ta,
  AngleArrowSmallRight: na,
  AngleArrowSmallUp: sa,
  AngleArrowUp: ca,
  AngularLogo: St,
  Aperture: su,
  AppStoreLogo: dt,
  AppWindow: Sd,
  AppleLogo: Ct,
  ApplePodcastsLogo: ht,
  Apply: ra,
  Archive: Ng,
  ArchiveBox: vg,
  ArchiveTray: xg,
  Armchair: mn,
  ArrowArcLeft: e,
  ArrowArcRight: y,
  ArrowBendDoubleUpLeft: l,
  ArrowBendDoubleUpRight: u,
  ArrowBendDownLeft: g,
  ArrowBendDownRight: S,
  ArrowBendLeftDown: C,
  ArrowBendLeftUp: h,
  ArrowBendRightDown: d,
  ArrowBendRightUp: w,
  ArrowBendUpLeft: A,
  ArrowBendUpRight: L,
  ArrowBottom: ia,
  ArrowCircleDown: k,
  ArrowCircleDownLeft: P,
  ArrowCircleDownRight: F,
  ArrowCircleLeft: b,
  ArrowCircleRight: T,
  ArrowCircleUp: B,
  ArrowCircleUpLeft: f,
  ArrowCircleUpRight: D,
  ArrowClockwise: R,
  ArrowCounterClockwise: H,
  ArrowDown: M,
  ArrowDownLeft: U,
  ArrowDownRight: N,
  ArrowElbowDownLeft: v,
  ArrowElbowDownRight: x,
  ArrowElbowLeft: E,
  ArrowElbowLeftDown: G,
  ArrowElbowLeftUp: W,
  ArrowElbowRight: O,
  ArrowElbowRightDown: q,
  ArrowElbowRightUp: I,
  ArrowElbowUpLeft: V,
  ArrowElbowUpRight: z,
  ArrowFatDown: X,
  ArrowFatLeft: K,
  ArrowFatLineDown: j,
  ArrowFatLineLeft: J,
  ArrowFatLineRight: Z,
  ArrowFatLineUp: oo,
  ArrowFatLinesDown: Q,
  ArrowFatLinesLeft: _,
  ArrowFatLinesRight: Y,
  ArrowFatLinesUp: $,
  ArrowFatRight: to,
  ArrowFatUp: no,
  ArrowLeft: so,
  ArrowLeftAlt: aa,
  ArrowLeftBottom: pa,
  ArrowLeftTop: ma,
  ArrowLineDown: co,
  ArrowLineDownLeft: ro,
  ArrowLineDownRight: io,
  ArrowLineLeft: ao,
  ArrowLineRight: po,
  ArrowLineUp: mo,
  ArrowLineUpLeft: eo,
  ArrowLineUpRight: yo,
  ArrowRight: lo,
  ArrowRightAlt: ea,
  ArrowRightBottom: ya,
  ArrowRightTop: la,
  ArrowSquareDown: Do,
  ArrowSquareDownLeft: Ro,
  ArrowSquareDownRight: Ho,
  ArrowSquareIn: Mo,
  ArrowSquareLeft: Uo,
  ArrowSquareOut: No,
  ArrowSquareRight: vo,
  ArrowSquareUp: xo,
  ArrowSquareUpLeft: Eo,
  ArrowSquareUpRight: Go,
  ArrowTop: Sa,
  ArrowUDownLeft: Oo,
  ArrowUDownRight: qo,
  ArrowULeftDown: Io,
  ArrowULeftUp: Vo,
  ArrowURightDown: jo,
  ArrowURightUp: Jo,
  ArrowUUpLeft: Zo,
  ArrowUUpRight: Qo,
  ArrowUp: zo,
  ArrowUpLeft: Xo,
  ArrowUpRight: Ko,
  ArrowsClockwise: uo,
  ArrowsCounterClockwise: go,
  ArrowsDownUp: So,
  ArrowsHorizontal: Co,
  ArrowsIn: ho,
  ArrowsInCardinal: wo,
  ArrowsInLineHorizontal: Ao,
  ArrowsInLineVertical: Lo,
  ArrowsInSimple: ko,
  ArrowsLeftAndRight: ua,
  ArrowsLeftRight: Po,
  ArrowsOut: Fo,
  ArrowsOutCardinal: bo,
  ArrowsOutLineHorizontal: To,
  ArrowsOutLineVertical: Bo,
  ArrowsOutSimple: fo,
  ArrowsUpAndDown: ga,
  ArrowsVertical: Wo,
  Article: cu,
  ArticleMedium: ru,
  ArticleNyTimes: iu,
  Asterisk: Hs,
  AsteriskSimple: Ms,
  At: Us,
  Atom: KA,
  Baby: qC,
  Back: Ca,
  Backpack: en,
  Backspace: Cd,
  Bag: yn,
  BagSimple: ln,
  Balloon: un,
  Bandaids: Oe,
  Bank: $y,
  BarChart: ha,
  Barbell: qe,
  Barcode: gn,
  Barricade: ey,
  Baseball: Ym,
  Basketball: $m,
  Bathtub: Sn,
  BatteryCharging: hd,
  BatteryChargingVertical: dd,
  BatteryEmpty: wd,
  BatteryFull: Ad,
  BatteryHigh: Ld,
  BatteryLow: kd,
  BatteryMedium: Pd,
  BatteryPlus: Fd,
  BatteryWarning: bd,
  BatteryWarningVertical: Td,
  Bed: Ie,
  BedAlt: da,
  BeerBottle: Cn,
  BehanceLogo: wt,
  Bell: Bd,
  BellAlt: wa,
  BellRinging: fd,
  BellSimple: Dd,
  BellSimpleRinging: Rd,
  BellSimpleSlash: Hd,
  BellSimpleZ: Md,
  BellSlash: Ud,
  BellZ: Nd,
  BezierCurve: Ic,
  Bicycle: yy,
  Bin: Aa,
  Binoculars: hn,
  Bird: jA,
  Bluetooth: vd,
  BluetoothConnected: xd,
  BluetoothSlash: Ed,
  BluetoothX: Gd,
  Boat: ly,
  Book: Ui,
  BookBookmark: Ni,
  BookOpen: Wi,
  Bookmark: vi,
  BookmarkAlt: La,
  BookmarkSimple: Ei,
  Bookmarks: xi,
  BookmarksSimple: Gi,
  Books: Oi,
  BoundingBox: Vc,
  BoxesArrowsLeftRight: ka,
  BracketsAngle: ei,
  BracketsCurly: yi,
  BracketsRound: li,
  BracketsSquare: ui,
  Brain: Ve,
  Brandy: dn,
  Briefcase: Eg,
  BriefcaseMetal: Gg,
  Broadcast: Ns,
  Browser: Wd,
  Browsers: Od,
  Bug: gi,
  BugBeetle: Si,
  BugDroid: Ci,
  Buildings: wn,
  BuildingsAlt: Pa,
  Bulb: Fa,
  Bus: uy,
  Butterfly: JA,
  Cactus: ZA,
  Cake: An,
  Calculator: ol,
  CalculatorAlt: ba,
  Calendar: BA,
  CalendarAlt: Ta,
  CalendarBlank: fA,
  CalendarCheck: DA,
  CalendarPlus: RA,
  CalendarX: HA,
  Camera: au,
  CameraAlt: Ba,
  CameraRotate: pu,
  CameraSlash: mu,
  Campfire: QA,
  Car: gy,
  CarSimple: Sy,
  CarTwo: Ha,
  Cardholder: Ln,
  Cards: Wg,
  CaretCircleDoubleDown: _o,
  CaretCircleDoubleLeft: Yo,
  CaretCircleDoubleRight: $o,
  CaretCircleDoubleUp: ot,
  CaretCircleDown: tt,
  CaretCircleLeft: nt,
  CaretCircleRight: st,
  CaretCircleUp: ct,
  CaretDoubleDown: rt,
  CaretDoubleLeft: it,
  CaretDoubleRight: at,
  CaretDoubleUp: pt,
  CaretDown: mt,
  CaretLeft: et,
  CaretRight: yt,
  CaretUp: lt,
  Cart: fa,
  CartCrossInside: Da,
  CartPlusInside: Ra,
  Case: Ma,
  Cat: _A,
  CellSignalFull: qd,
  CellSignalHigh: Id,
  CellSignalLow: Vd,
  CellSignalMedium: zd,
  CellSignalNone: Xd,
  CellSignalSlash: Kd,
  CellSignalX: jd,
  Chalkboard: qi,
  ChalkboardSimple: Ii,
  ChalkboardTeacher: Vi,
  ChartBar: tl,
  ChartBarHorizontal: nl,
  ChartLine: sl,
  ChartLineUp: cl,
  ChartPie: rl,
  ChartPieSlice: il,
  Chat: vs,
  ChatCentered: xs,
  ChatCenteredDots: Es,
  ChatCenteredText: Gs,
  ChatCircle: Ws,
  ChatCircleDots: Os,
  ChatCircleText: qs,
  ChatDots: Is,
  ChatTeardrop: Ks,
  ChatTeardropDots: js,
  ChatTeardropText: Js,
  ChatText: Zs,
  Chats: Vs,
  ChatsCircle: zs,
  ChatsTeardrop: Xs,
  Check: Jd,
  CheckCircle: Zd,
  CheckSquare: _d,
  CheckSquareOffset: Yd,
  CheckmarkRound: Ua,
  Checks: Qd,
  Circle: zc,
  CircleDashed: Xc,
  CircleHalf: Kc,
  CircleHalfTilt: jc,
  CircleNotch: Jc,
  CircleWavy: Nh,
  CircleWavyCheck: vh,
  CircleWavyQuestion: xh,
  CircleWavyWarning: Eh,
  CirclesFour: Zc,
  CirclesThree: Qc,
  CirclesThreePlus: _c,
  Clipboard: Og,
  ClipboardText: qg,
  Clock: MA,
  ClockAfternoon: UA,
  ClockClockwise: NA,
  ClockCounterClockwise: vA,
  ClosedCaptioning: eu,
  Cloud: YA,
  CloudArrowDown: $d,
  CloudArrowUp: ow,
  CloudCheck: tw,
  CloudCheckmarkOne: Na,
  CloudCopy: va,
  CloudCross: xa,
  CloudDisconnected: Ea,
  CloudDownload: Ga,
  CloudFog: $A,
  CloudLightning: oL,
  CloudMoon: tL,
  CloudRain: nL,
  CloudServerCopy: Wa,
  CloudSlash: nw,
  CloudSnow: sL,
  CloudSun: cL,
  CloudUpload: Oa,
  Club: oe,
  CoatHanger: kn,
  Code: hi,
  CodeSimple: di,
  CodepenLogo: At,
  CodesandboxLogo: Lt,
  Coffee: Pn,
  Coin: Fn,
  CoinVertical: Tn,
  Coins: bn,
  Collapse: qa,
  CollapseSmall: Ia,
  Columns: Yc,
  Command: sw,
  Compass: Cy,
  ComputerTower: cw,
  Confetti: te,
  Cookie: Bn,
  CookingPot: fn,
  Copy: Ig,
  CopySimple: Vg,
  Copyleft: yu,
  Copyright: lu,
  CornersIn: uu,
  CornersOut: gu,
  Cpu: wi,
  CreditCard: Dn,
  CreditCardAlt: Va,
  Crop: $c,
  Cross: za,
  Crosshair: hy,
  CrosshairSimple: dy,
  Crown: ne,
  CrownSimple: se,
  Cube: or,
  CurrencyBtc: Rn,
  CurrencyCircleDollar: Hn,
  CurrencyCny: Mn,
  CurrencyDollar: Un,
  CurrencyDollarSimple: Nn,
  CurrencyEth: vn,
  CurrencyEur: xn,
  CurrencyGbp: En,
  CurrencyInr: Gn,
  CurrencyJpy: Wn,
  CurrencyKrw: On,
  CurrencyKzt: qn,
  CurrencyNgn: In,
  CurrencyRub: Vn,
  Cursor: rw,
  CursorAlt: Xa,
  CursorText: zg,
  Cylinder: tr,
  DashboardFour: Ka,
  DashboardLines: ja,
  Database: Ai,
  DatabaseOne: Ja,
  Desktop: iw,
  DesktopTower: aw,
  Detective: Gh,
  DeviceMobile: pw,
  DeviceMobileCamera: mw,
  DeviceMobileSpeaker: ew,
  DeviceTablet: yw,
  DeviceTabletCamera: lw,
  DeviceTabletSpeaker: uw,
  Dialog: Za,
  Diamond: ce,
  DiamondAlt: Qa,
  DiamondsFour: nr,
  DiceFive: re,
  DiceFour: ie,
  DiceOne: ae,
  DiceSix: pe,
  DiceThree: me,
  DiceTwo: ee,
  Disc: Su,
  DiscordLogo: kt,
  Distance: _a,
  Divide: al,
  Dog: rL,
  Door: wy,
  DotsNine: gw,
  DotsSix: Sw,
  DotsSixVertical: Cw,
  DotsThree: hw,
  DotsThreeCircle: dw,
  DotsThreeCircleVertical: ww,
  DotsThreeOutline: Aw,
  DotsThreeOutlineVertical: Lw,
  DotsThreeVertical: kw,
  Download: Pw,
  DownloadAlt: Ya,
  DownloadSimple: Fw,
  Drag: $a,
  DribbbleLogo: Pt,
  Drop: iL,
  DropHalf: sr,
  DropHalfBottom: cr,
  DropperOne: op,
  Ear: Cu,
  EarSlash: hu,
  Earth: tp,
  Egg: zn,
  EggCrack: Xn,
  Eject: du,
  EjectSimple: wu,
  Envelope: Qs,
  EnvelopeOpen: _s,
  EnvelopeSimple: Ys,
  EnvelopeSimpleOpen: $s,
  Equalizer: Au,
  Equals: pl,
  Eraser: rr,
  Exam: zi,
  ExitLeft: np,
  ExitRight: sp,
  Expand: cp,
  ExpandSmall: rp,
  Export: oc,
  Eye: ir,
  EyeAlt: ip,
  EyeClosed: ar,
  EyeCrossedOut: ap,
  EyeSlash: er,
  Eyedropper: pr,
  EyedropperSample: mr,
  Eyeglasses: Kn,
  FaceMask: ze,
  FacebookLogo: Ft,
  Factory: jn,
  Faders: Lu,
  FadersHorizontal: ku,
  FastForward: Pu,
  FastForwardCircle: Fu,
  FigmaLogo: bt,
  File: Xg,
  FileArrowDown: Kg,
  FileArrowUp: jg,
  FileAudio: Jg,
  FileCloud: Zg,
  FileCode: Qg,
  FileCss: _g,
  FileCsv: Yg,
  FileDoc: $g,
  FileDotted: oS,
  FileHtml: tS,
  FileImage: nS,
  FileJpg: sS,
  FileJs: cS,
  FileJsx: rS,
  FileLock: iS,
  FileMinus: aS,
  FilePdf: pS,
  FilePlus: mS,
  FilePng: eS,
  FilePpt: yS,
  FileRs: lS,
  FileSearch: gS,
  FileText: SS,
  FileTs: CS,
  FileTsx: hS,
  FileVideo: dS,
  FileVue: wS,
  FileX: AS,
  FileXls: LS,
  FileZip: kS,
  Files: uS,
  FilmScript: bu,
  FilmSlate: Tu,
  FilmStrip: Bu,
  Filter: pp,
  Fingerprint: Wh,
  FingerprintSimple: Oh,
  FinnTheHuman: ye,
  Fire: aL,
  FireSimple: pL,
  FirstAid: Xe,
  FirstAidKit: Ke,
  Fish: mL,
  FishSimple: eL,
  Flag: Ay,
  FlagAlt: mp,
  FlagBanner: Ly,
  FlagCheckered: ky,
  Flame: yL,
  Flash: ep,
  Flashlight: bw,
  Flask: je,
  FloppyDisk: PS,
  FloppyDiskBack: FS,
  FlowArrow: yr,
  Flower: lL,
  FlowerLotus: uL,
  FlyingSaucer: le,
  Folder: bS,
  FolderClosed: lp,
  FolderDotted: TS,
  FolderLock: BS,
  FolderMinus: fS,
  FolderNotch: DS,
  FolderNotchMinus: RS,
  FolderNotchOpen: HS,
  FolderNotchPlus: MS,
  FolderOpen: US,
  FolderOpenAlt: yp,
  FolderPlus: NS,
  FolderSimple: xS,
  FolderSimpleDotted: ES,
  FolderSimpleLock: GS,
  FolderSimpleMinus: WS,
  FolderSimplePlus: OS,
  FolderSimpleStar: qS,
  FolderSimpleUser: IS,
  FolderStar: VS,
  FolderUser: zS,
  Folders: vS,
  Football: ue,
  ForkKnife: Jn,
  FrameCorners: fu,
  FramerLogo: Tt,
  FullScreen: up,
  Function: ml,
  Funnel: XS,
  FunnelSimple: KS,
  GameController: ge,
  GamePad: gp,
  GasPump: Py,
  Gauge: Tw,
  Gear: Bw,
  GearAlt: Sp,
  GearSix: fw,
  GenderFemale: IC,
  GenderIntersex: VC,
  GenderMale: zC,
  GenderNeuter: XC,
  GenderNonbinary: KC,
  GenderTransgender: jC,
  Ghost: Se,
  Gif: Du,
  Gift: Zn,
  GitBranch: Li,
  GitCommit: ki,
  GitDiff: Pi,
  GitFork: Fi,
  GitMerge: bi,
  GitPullRequest: Ti,
  GithubLogo: Bt,
  GitlabLogo: ft,
  GitlabLogoSimple: Dt,
  Globe: Fy,
  GlobeHemisphereEast: by,
  GlobeHemisphereWest: Ty,
  GlobeSimple: By,
  GlobeStand: fy,
  GoogleChromeLogo: Rt,
  GoogleLogo: Ht,
  GooglePhotosLogo: Mt,
  GooglePlayLogo: Ut,
  GooglePodcastsLogo: Nt,
  Gradient: lr,
  GraduationCap: Xi,
  Graph: el,
  GridFour: ur,
  Hamburger: Qn,
  HamburgerMenu: Cp,
  Hand: JC,
  HandCoins: $n,
  HandEye: ZC,
  HandFist: QC,
  HandGrabbing: _C,
  HandPalm: YC,
  HandPointer: hp,
  HandPointing: $C,
  HandSoap: Je,
  HandWaving: nh,
  Handbag: _n,
  HandbagSimple: Yn,
  HandsClapping: oh,
  Handshake: th,
  HardDrive: Dw,
  HardDrives: Rw,
  Hash: tc,
  HashAlt: dp,
  HashStraight: nc,
  Headlights: Dy,
  Headphones: Ru,
  HeadphonesAlt: wp,
  HeadphonesWithMicrophone: Ap,
  Headset: Hu,
  Heart: Ce,
  HeartAlt: Lp,
  HeartBreak: he,
  HeartFilled: kp,
  HeartStraight: de,
  HeartStraightBreak: we,
  Heartbeat: Ze,
  Hexagon: gr,
  HighlighterCircle: Sr,
  Horse: Ae,
  Hourglass: xA,
  HourglassHigh: EA,
  HourglassLow: GA,
  HourglassMedium: WA,
  HourglassSimple: OA,
  HourglassSimpleHigh: qA,
  HourglassSimpleLow: IA,
  HourglassSimpleMedium: VA,
  House: Ry,
  HouseLine: Hy,
  HouseSimple: My,
  IdentificationBadge: sh,
  IdentificationCard: ch,
  Image: Mu,
  ImageSquare: Uu,
  InfinityIcon: yl,
  Info: qh,
  InfoAlt: Pp,
  InstagramLogo: vt,
  Intersect: Cr,
  Jeep: Uy,
  Kanban: jS,
  Key: Ih,
  KeyReturn: Mw,
  Keyboard: Hw,
  Keyhole: Vh,
  Knife: os,
  Label: Fp,
  Ladder: ts,
  LadderSimple: ns,
  Lamp: ss,
  Laptop: Uw,
  Layout: hr,
  Leaf: gL,
  Lifebuoy: Qe,
  Lightbulb: Nw,
  LightbulbFilament: vw,
  Lightning: xw,
  LightningAlt: bp,
  LightningSlash: Ew,
  LineSegment: dr,
  LineSegments: wr,
  Link: Gw,
  LinkAlt: Tp,
  LinkBreak: Ww,
  LinkSimple: Ow,
  LinkSimpleBreak: qw,
  LinkSimpleHorizontal: Iw,
  LinkSimpleHorizontalBreak: Vw,
  LinkedinLogo: xt,
  LinuxLogo: Et,
  List: JS,
  ListAlt: Bp,
  ListBullets: ZS,
  ListCheckmarks: fp,
  ListChecks: QS,
  ListDashes: _S,
  ListNumbers: YS,
  ListPlus: $S,
  Location: Dp,
  Lock: zh,
  LockClosed: Rp,
  LockKey: Xh,
  LockKeyOpen: Kh,
  LockLaminated: jh,
  LockLaminatedOpen: Jh,
  LockOpen: Zh,
  LockOpened: Hp,
  LockSimple: Qh,
  LockSimpleOpen: _h,
  MagicWand: Ar,
  Magnet: Bi,
  MagnetStraight: fi,
  Magnifier: Mp,
  MagnifierMinus: Up,
  MagnifierPlus: Np,
  MagnifyingGlass: zw,
  MagnifyingGlassMinus: Xw,
  MagnifyingGlassPlus: Kw,
  Mail: vp,
  MapPin: Ny,
  MapPinLine: vy,
  MapTrifold: xy,
  MarkerCircle: Lr,
  Martini: cs,
  MaskHappy: Le,
  MaskSad: ke,
  MathOperations: ll,
  Medal: Pe,
  MedicalCross: xp,
  MediumLogo: Gt,
  Megaphone: sc,
  MegaphoneSimple: cc,
  MessengerLogo: Wt,
  Microphone: Nu,
  MicrophoneAlt: Ep,
  MicrophoneSlash: vu,
  MicrophoneStage: xu,
  MicrosoftExcelLogo: Ot,
  MicrosoftPowerpointLogo: qt,
  MicrosoftTeamsLogo: It,
  MicrosoftWordLogo: Vt,
  Minus: ul,
  MinusCircle: gl,
  MinusRound: Gp,
  Money: rs,
  MoneyAlt: Wp,
  Monitor: jw,
  MonitorOne: Op,
  MonitorPhoneTwo: qp,
  MonitorPlay: Jw,
  Moon: SL,
  MoonStars: CL,
  Mountains: hL,
  Mouse: Zw,
  MouseAlt: Ip,
  MouseSimple: Qw,
  Music: Vp,
  MusicNote: Eu,
  MusicNoteSimple: Wu,
  MusicNotes: Gu,
  MusicNotesPlus: Ou,
  MusicNotesSimple: qu,
  NavigationArrow: Ey,
  Needle: is,
  Network: zp,
  Newspaper: Iu,
  NewspaperClipping: Vu,
  NoSound: Xp,
  Note: oC,
  NoteBlank: tC,
  NotePencil: cC,
  Notebook: nC,
  Notepad: sC,
  NotesVertical: Kp,
  Notification: _w,
  NumberCircleEight: Sl,
  NumberCircleFive: Cl,
  NumberCircleFour: hl,
  NumberCircleNine: dl,
  NumberCircleOne: wl,
  NumberCircleSeven: Al,
  NumberCircleSix: Ll,
  NumberCircleThree: kl,
  NumberCircleTwo: Pl,
  NumberCircleZero: Fl,
  NumberEight: bl,
  NumberFive: Tl,
  NumberFour: Bl,
  NumberNine: fl,
  NumberOne: Dl,
  NumberSeven: Rl,
  NumberSix: Hl,
  NumberSquareEight: Ml,
  NumberSquareFive: Ul,
  NumberSquareFour: Nl,
  NumberSquareNine: vl,
  NumberSquareOne: xl,
  NumberSquareSeven: El,
  NumberSquareSix: Gl,
  NumberSquareThree: Wl,
  NumberSquareTwo: Ol,
  NumberSquareZero: ql,
  NumberThree: Il,
  NumberTwo: Vl,
  NumberZero: zl,
  Nut: Yw,
  NyTimesLogo: zt,
  Octagon: kr,
  Option: $w,
  Package: as,
  PackageAlt: jp,
  PaintBrush: Pr,
  PaintBrushBroad: Fr,
  PaintBrushHousehold: br,
  PaintBucket: Tr,
  PaintRoller: Br,
  Palette: fr,
  Paper: Jp,
  PaperPlane: rc,
  PaperPlaneRight: ic,
  PaperPlaneTilt: ac,
  Paperclip: rC,
  PaperclipAlt: Zp,
  PaperclipHorizontal: iC,
  Parachute: Fe,
  ParkingCircle: Qp,
  Password: Yh,
  Path: Gy,
  Pause: zu,
  PauseCircle: Xu,
  PawPrint: dL,
  Peace: pc,
  Pen: Dr,
  PenNib: vr,
  PenNibStraight: xr,
  Pencil: Rr,
  PencilCircle: Hr,
  PencilLine: Mr,
  PencilSimple: Ur,
  PencilSimpleLine: Nr,
  Pensil: _p,
  Percent: Xl,
  PercentSymbol: Yp,
  Person: rh,
  PersonSimple: ih,
  PersonSimpleRun: ah,
  PersonSimpleWalk: ph,
  Perspective: Er,
  Phone: mc,
  PhoneCall: ec,
  PhoneCheckmark: $p,
  PhoneDisconnect: yc,
  PhoneIncoming: lc,
  PhoneMinus: om,
  PhoneOutgoing: uc,
  PhonePlus: tm,
  PhoneRings: nm,
  PhoneSlash: gc,
  PhoneX: Sc,
  PhosphorLogo: Xt,
  PianoKeys: Ku,
  Picture: sm,
  PictureInPicture: ju,
  PieChart: cm,
  Pill: _e,
  Pin: rm,
  PinterestLogo: Kt,
  Pinwheel: be,
  Pizza: ps,
  Placeholder: Gr,
  Plane: im,
  Planet: wL,
  Play: Ju,
  PlayCircle: Zu,
  PlayVideoRectangle: am,
  Playlist: Qu,
  Plug: oA,
  Plugs: tA,
  PlugsConnected: nA,
  Plus: Kl,
  PlusAlt: pm,
  PlusCircle: jl,
  PlusMinus: Jl,
  PlusRound: mm,
  PokerChip: Te,
  PokerFace: em,
  PoliceCar: Wy,
  Polygon: Wr,
  Popcorn: ms,
  Power: sA,
  Prescription: Ye,
  Presentation: aC,
  PresentationChart: pC,
  Printer: mC,
  Prohibit: $h,
  ProhibitInset: od,
  ProjectorScreen: eC,
  ProjectorScreenChart: yC,
  PushPin: lC,
  PushPinSimple: uC,
  PushPinSimpleSlash: gC,
  PushPinSlash: SC,
  PuzzlePiece: Be,
  QrCode: cA,
  Question: td,
  Queue: _u,
  Quotes: Cc,
  Radical: Zl,
  Radio: hc,
  RadioButton: rA,
  Rainbow: AL,
  RainbowCloud: LL,
  Receipt: es,
  Record: Yu,
  Recover: ym,
  Rectangle: Or,
  Recycle: ut,
  RedditLogo: jt,
  Repeat: $u,
  RepeatAlt: lm,
  RepeatOnce: og,
  RestoreDown: um,
  Rewind: tg,
  RewindCircle: ng,
  Robot: Di,
  Rocket: Oy,
  RocketLaunch: qy,
  Rows: qr,
  Rss: dc,
  RssSimple: wc,
  Rug: ys,
  Ruler: Ir,
  Sad: gm,
  Save: Sm,
  Scales: ls,
  Scan: iA,
  Scissors: Vr,
  Screencast: sg,
  ScribbleLoop: zr,
  Scroll: fe,
  Selection: Xr,
  SelectionAll: Kr,
  SelectionBackground: jr,
  SelectionForeground: Jr,
  SelectionInverse: Zr,
  SelectionPlus: Qr,
  SelectionSlash: _r,
  SettingsVertical: Cm,
  Share: Ac,
  ShareNetwork: Lc,
  Shield: nd,
  ShieldCheck: sd,
  ShieldCheckered: cd,
  ShieldChevron: rd,
  ShieldOne: hm,
  ShieldPlus: id,
  ShieldSlash: ad,
  ShieldStar: pd,
  ShieldWarning: md,
  ShoppingBag: us,
  ShoppingBagHandlesDown: dm,
  ShoppingBagOpen: gs,
  ShoppingCart: Ss,
  ShoppingCartSimple: Cs,
  Shower: hs,
  Shuffle: cg,
  ShuffleAngular: rg,
  ShuffleSimple: ig,
  Sidebar: Yr,
  SidebarSimple: $r,
  SignIn: aA,
  SignOut: pA,
  Signpost: Iy,
  SimCard: mA,
  SketchLogo: Jt,
  SkipBack: ag,
  SkipBackCircle: pg,
  SkipForward: mg,
  SkipForwardCircle: eg,
  Skull: De,
  SlackLogo: Zt,
  Sliders: yg,
  SlidersHorizontal: lg,
  Smartphone: wm,
  Smile: Am,
  Smiley: mh,
  SmileyBlank: eh,
  SmileyMeh: yh,
  SmileyNervous: lh,
  SmileySad: uh,
  SmileySticker: gh,
  SmileyWink: Sh,
  SmileyXEyes: Ch,
  SnapchatLogo: Qt,
  Snowflake: kL,
  SoccerBall: Re,
  Sort: Lm,
  SortArrowDown: km,
  SortArrowUp: Pm,
  SortAscending: CC,
  SortDescending: hC,
  SoundHigh: Fm,
  SoundLow: bm,
  Spade: He,
  Sparkle: PL,
  SpeakerHigh: ug,
  SpeakerLow: gg,
  SpeakerNone: Sg,
  SpeakerSimpleHigh: Cg,
  SpeakerSimpleLow: hg,
  SpeakerSimpleNone: dg,
  SpeakerSimpleSlash: wg,
  SpeakerSimpleX: Ag,
  SpeakerSlash: Lg,
  SpeakerX: kg,
  SpeechBubble: Tm,
  Spinner: eA,
  SpinnerGap: yA,
  Spiral: Me,
  SplitScreenHorizontal: Bm,
  SplitScreenVertical: fm,
  SpoonAndFork: Dm,
  SpotifyLogo: _t,
  Square: oi,
  SquareHalf: ti,
  SquareHalfBottom: ni,
  SquareLogo: Yt,
  SquaresFour: si,
  Stack: ci,
  StackOverflowLogo: $t,
  StackSimple: ri,
  Stamp: ii,
  Star: kc,
  StarAlt: Rm,
  StarFour: FL,
  StarHalf: Pc,
  Sticker: Fc,
  Stop: Pg,
  StopCircle: Fg,
  Storefront: ds,
  Strategy: Ue,
  StripeLogo: on,
  Student: Ki,
  Suitcase: Vy,
  SuitcaseSimple: zy,
  Sun: bL,
  SunDim: TL,
  SunHorizon: BL,
  Sunglasses: ws,
  Swap: lA,
  Swatches: ai,
  Sword: Ne,
  Syringe: $e,
  TShirt: Bs,
  Table: Ql,
  TableAlt: Hm,
  Tabs: uA,
  Tag: As,
  TagChevron: Ls,
  TagSimple: ks,
  Target: ve,
  TargetAlt: Mm,
  Taxi: Xy,
  TelegramLogo: tn,
  Television: bg,
  TelevisionSimple: Tg,
  TennisBall: xe,
  Terminal: Ri,
  TerminalWindow: Hi,
  TestTube: oy,
  TextAa: dC,
  TextAlignCenter: wC,
  TextAlignJustify: AC,
  TextAlignLeft: LC,
  TextAlignRight: kC,
  TextBolder: PC,
  TextH: bC,
  TextHFive: TC,
  TextHFour: BC,
  TextHOne: fC,
  TextHSix: DC,
  TextHThree: RC,
  TextHTwo: HC,
  TextIndent: MC,
  TextItalic: UC,
  TextOutdent: NC,
  TextStrikethrough: vC,
  TextT: xC,
  TextUnderline: EC,
  Textbox: FC,
  Thermometer: fL,
  ThermometerCold: DL,
  ThermometerHot: RL,
  ThermometerSimple: HL,
  ThumbsDown: bc,
  ThumbsDownAlt: Um,
  ThumbsUp: Tc,
  ThumbsUpAlt: Nm,
  Ticket: Ps,
  TiktokLogo: nn,
  Timer: zA,
  ToggleLeft: gA,
  ToggleRight: SA,
  Toilet: ty,
  ToiletPaper: ny,
  Tools: vm,
  Tote: Fs,
  ToteSimple: bs,
  TrademarkRegistered: Ts,
  TrafficCone: Ky,
  TrafficSign: jy,
  TrafficSignal: Jy,
  Train: Zy,
  TrainRegional: Qy,
  TrainSimple: _y,
  Translate: Bc,
  Trash: GC,
  TrashSimple: WC,
  Tray: OC,
  Tree: ML,
  TreeEvergreen: UL,
  TreeStructure: Mi,
  TrendDown: _l,
  TrendUp: Yl,
  Triangle: pi,
  Trophy: Ee,
  Truck: Yy,
  TruckAlt: xm,
  TwitchLogo: sn,
  TwitterLogo: cn,
  Umbrella: NL,
  UmbrellaSimple: vL,
  UnevenLineGraph: Em,
  Upload: CA,
  UploadAlt: Gm,
  UploadSimple: hA,
  UsdCircle: Wm,
  User: hh,
  UserAlt: Om,
  UserCircle: dh,
  UserCircleGear: wh,
  UserCircleMinus: Ah,
  UserCirclePlus: Lh,
  UserFocus: kh,
  UserGear: Ph,
  UserList: Fh,
  UserMinus: bh,
  UserPlus: Th,
  UserRectangle: Bh,
  UserRound: qm,
  UserSquare: Rh,
  UserSwitch: Mh,
  Users: fh,
  UsersAlt: Im,
  UsersFour: Dh,
  UsersThree: Hh,
  Vault: ed,
  Vibrate: dA,
  VideoCamera: Bg,
  VideoCameraAlt: Vm,
  VideoCameraSlash: fg,
  Vignette: mi,
  Voicemail: fc,
  Volleyball: Ge,
  Waiting: zm,
  Wall: yd,
  Wallet: fs,
  Warning: ld,
  WarningAlt: Xm,
  WarningCircle: ud,
  WarningOctagon: gd,
  Watch: XA,
  WatchAlt: Km,
  WaveSawtooth: Dg,
  WaveSine: Rg,
  WaveSquare: Hg,
  WaveTriangle: Mg,
  Waves: xL,
  Webcam: Ug,
  Website: jm,
  WhatsappLogo: rn,
  Wheelchair: Uh,
  WifiHigh: wA,
  WifiLow: AA,
  WifiMedium: LA,
  WifiNone: kA,
  WifiSlash: PA,
  WifiX: FA,
  Wind: EL,
  WindowsLogo: an,
  Wine: Ds,
  Wrench: bA,
  WrenchAlt: Jm,
  Writing: Zm,
  X: $l,
  XCircle: ou,
  XRound: Qm,
  XSquare: tu,
  YinYang: Dc,
  YoutubeLogo: pn
}, Symbol.toStringTag, { value: "Module" })), qL = ({ icon: t, className: s, rotate: c, ...i }) => {
  const r = p(() => GL[t], [t]);
  return r ? /* @__PURE__ */ n(
    "div",
    {
      className: s,
      "aria-label": t,
      role: "img",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transform: c ? `rotate(${c}deg)` : void 0
      },
      ...i,
      children: /* @__PURE__ */ n(m, { fallback: null, children: /* @__PURE__ */ n(r, { style: { width: "100%", height: "100%" } }) })
    }
  ) : null;
};
export {
  qL as Icon
};
